<template>
  <div class="health_rear">
    <van-nav-bar title="饲养标准" v-if="isWx==1" left-arrow @click-left="onClickLeft" fixed></van-nav-bar>
    <van-nav-bar title="饲养标准" v-else fixed></van-nav-bar>
    <div class="navheight"></div>
    <div class="swine_wrap"> 
        <van-row>
            <van-collapse v-model="activeNames">
                <van-collapse-item title="1、瘦肉型生长育肥猪每千克饲粮养分含量" name="1">
                    <van-row>
                        <van-col span="24">
                            
                            <van-col span="24">
                                自由采食，88%干物质
                            </van-col>
                          
                            <table class="health_tab">
                                <tr>
                                    <th style="width:100px;">体重BW，kg</th>
                                    <th>3~8</th>
                                    <th>8~20</th>
                                    <th>20~35</th>
                                    <th>35~60</th>
                                    <th>60~90</th>
                                </tr>
                                <tr>
                                    <td>平均体重Average BW，kg</td>
                                    <td>5.5</td>
                                    <td>14.0</td>
                                    <td>27.5</td>
                                    <td>47.5</td>
                                    <td>75.0</td>
                                </tr>
                                <tr>
                                    <td>日增重ADG，kg/d</td>
                                    <td>0.24</td>
                                    <td>0.44</td>
                                    <td>0.61</td>
                                    <td>0.69</td>
                                    <td>0.80</td>
                                </tr>
                                <tr>                              					
                                    <td>采食量ADFI，kg/d</td>
                                    <td>0.30</td>
                                    <td>0.74</td>
                                    <td>1.43</td>
                                    <td>1.90</td>
                                    <td>2.50</td>
                                </tr>
                                <tr>                              					
                                    <td>饲料/增重 F/G</td>
                                    <td>1.25</td>
                                    <td>1.59</td>
                                    <td>2.34</td>
                                    <td>2.75</td>
                                    <td>3.13</td>
                                </tr>
                                <tr>                              					
                                    <td>饲粮消化能含量DE，MJ/kg(kcal/kg)</td>
                                    <td>14.02(3350)</td>
                                    <td>13.60(3250)</td>
                                    <td>13.39(3200)</td>
                                    <td>13.39(3200)</td>
                                    <td>13.39(3200)</td>
                                </tr>
                                <tr>                              					
                                    <td>饲粮代谢能含量ME,MJ/kg(kcal/kg)</td>
                                    <td>13.46(3215)</td>
                                    <td>13.06(3120) </td>
                                    <td>12.86(3070)</td>
                                    <td>12.86(3070)</td>
                                    <td>12.86(3070)</td>
                                </tr>
                                <tr>                              					
                                    <td>粗蛋白质CP，%</td>
                                    <td>21.0</td>
                                    <td>19.0 </td>
                                    <td>17.8</td>
                                    <td>16.4</td>
                                    <td>14.5</td>
                                </tr>				
                                <tr>                              					
                                    <td>能量蛋白比DE/CP,kg%(kcal/%)</td>
                                    <td>668(160)</td>
                                    <td>716(170) </td>
                                    <td>752(180)</td>
                                    <td>817(195)</td>
                                    <td>923(220)</td>
                                </tr>	 			
                                <tr>                              					
                                    <td>赖氨酸能量比Lys/DE,g/MJ(g/Mcal)</td>
                                    <td>1.01(4.24)</td>
                                    <td>0.85(3.56) </td>
                                    <td>0.68(2.83)</td>
                                    <td>0.61(2.56)</td>
                                    <td>0.53(2.19)</td>
                                </tr>
                                <tr>                              					
                                    <td colspan="6">氨基酸，%</td>
                                    
                                </tr>
                                <tr>                              					
                                    <td>赖氨酸Lys</td>
                                    <td>1.42</td>
                                    <td>1.16 </td>
                                    <td>0.90</td>
                                    <td>0.82</td>
                                    <td>0.70</td>
                                </tr>
                                <tr>                              					
                                    <td>蛋氨酸Met</td>
                                    <td>0.40</td>
                                    <td>0.30</td>
                                    <td>0.24</td>
                                    <td>0.22</td>
                                    <td>0.19</td>
                                </tr>					
                                <tr>                              					
                                    <td>蛋氨酸+胱氨酸Met+Cys</td>
                                    <td>0.81</td>
                                    <td>0.66</td>
                                    <td>0.51</td>
                                    <td>0.48</td>
                                    <td>0.40</td>
                                </tr>					
                                <tr>                              					
                                    <td>苏氨酸Thr</td>
                                    <td>0.94</td>
                                    <td>0.75</td>
                                    <td>0.58</td>
                                    <td>0.56</td>
                                    <td>0.48</td>
                                </tr>					
                                <tr>                              					
                                    <td>色氨酸Trp</td>
                                    <td>0.27</td>
                                    <td>0.21</td>
                                    <td>0.16</td>
                                    <td>0.15</td>
                                    <td>0.13</td>
                                </tr>					
                                <tr>                              					
                                    <td>异亮氨酸Ile</td>
                                    <td>0.79</td>
                                    <td>0.64</td>
                                    <td>0.48</td>
                                    <td>0.46</td>
                                    <td>0.39</td>
                                </tr>
                                <tr>                              					
                                    <td>亮氨酸Leu</td>
                                    <td>1.42</td>
                                    <td>1.13</td>
                                    <td>0.85</td>
                                    <td>0.79</td>
                                    <td>0.62</td>
                                </tr>
                                <tr>                              					
                                    <td>精氨酸Arg</td>
                                    <td>0.56</td>
                                    <td>0.46</td>
                                    <td>0.35</td>
                                    <td>0.30</td>
                                    <td>0.21</td>
                                </tr>	
                                <tr>                              					
                                    <td>缬氨酸Val</td>
                                    <td>0.98</td>
                                    <td>0.80</td>
                                    <td>0.61</td>
                                    <td>0.57</td>
                                    <td>0.47</td>
                                </tr>
                                <tr>                              					
                                    <td>组氨酸His</td>
                                    <td>0.56</td>
                                    <td>0.36</td>
                                    <td>0.28</td>
                                    <td>0.26</td>
                                    <td>0.21</td>
                                </tr>
                                <tr>                              					
                                    <td>苯丙氨酸Phe</td>
                                    <td>0.85</td>
                                    <td>0.69</td>
                                    <td>0.52</td>
                                    <td>0.48</td>
                                    <td>0.40</td>
                                </tr>
                                <tr>                              					
                                    <td>酪氨酸Phe</td>
                                    <td>1.33</td>
                                    <td>1.07</td>
                                    <td>0.82</td>
                                    <td>0.77</td>
                                    <td>0.64</td>
                                </tr>
                                <tr>                              					
                                    <td colspan="6">矿物元素，%或每千饲粮含量</td>
                                    
                                </tr>
                                <tr>                              					
                                    <td>钙Ca，%</td>
                                    <td>0.88</td>
                                    <td>0.74</td>
                                    <td>0.62</td>
                                    <td>0.55</td>
                                    <td>0.49</td>
                                </tr>
                                <tr>                              					
                                    <td>总磷，%</td>
                                    <td>0.74</td>
                                    <td>0.58</td>
                                    <td>0.53</td>
                                    <td>0.48</td>
                                    <td>0.43</td>
                                </tr>
                                <tr>                              					
                                    <td>非植酸磷，%</td>
                                    <td>0.54</td>
                                    <td>0.36</td>
                                    <td>0.25</td>
                                    <td>0.20</td>
                                    <td>0.17</td>
                                </tr>
                                <tr>                              					
                                    <td>钠Na，%</td>
                                    <td>0.25</td>
                                    <td>0.15</td>
                                    <td>0.12</td>
                                    <td>0.10</td>
                                    <td>0.10</td>
                                </tr>
                                <tr>                              					
                                    <td>氯Cl，%</td>
                                    <td>0.25</td>
                                    <td>0.15</td>
                                    <td>0.10</td>
                                    <td>0.09</td>
                                    <td>0.08</td>
                                </tr>
                                <tr>                              					
                                    <td>镁Mg，%</td>
                                    <td>0.04</td>
                                    <td>0.04</td>
                                    <td>0.04</td>
                                    <td>0.04</td>
                                    <td>0.04</td>
                                </tr>
                                <tr>                              					
                                    <td>钾K，%</td>
                                    <td>0.30</td>
                                    <td>0.26</td>
                                    <td>0.24</td>
                                    <td>0.21</td>
                                    <td>0.18</td>
                                </tr>
                                <tr>                              					
                                    <td>铜Cu，mg</td>
                                    <td>6.00</td>
                                    <td>6.00</td>
                                    <td>4.50</td>
                                    <td>4.00</td>
                                    <td>3.50</td>
                                </tr>
                                <tr>                              					
                                    <td>碘I，mg</td>
                                    <td>0.14</td>
                                    <td>0.14</td>
                                    <td>0.14</td>
                                    <td>0.14</td>
                                    <td>0.14</td>
                                </tr>
                                <tr>                              					
                                    <td>铁Fe，mg</td>
                                    <td>105</td>
                                    <td>105</td>
                                    <td>70</td>
                                    <td>60</td>
                                    <td>50</td>
                                </tr>
                                <tr>                              					
                                    <td>锰Mn，mg</td>
                                    <td>4.00</td>
                                    <td>4.00</td>
                                    <td>3.00</td>
                                    <td>2.00</td>
                                    <td>2.0</td>
                                </tr>
                                 <tr>                              					
                                    <td>硒Se，mg</td>
                                    <td>0.30</td>
                                    <td>0.30</td>
                                    <td>0.30</td>
                                    <td>0.25</td>
                                    <td>0.25</td>
                                </tr>
                                <tr>                              					
                                    <td>锌Zn，mg</td>
                                    <td>110</td>
                                    <td>110</td>
                                    <td>70</td>
                                    <td>60</td>
                                    <td>50</td>
                                </tr>
                                <tr>                              					
                                    <td colspan="6">维生素和脂肪酸，%或每千克饲粮含量</td>
                                    
                                </tr>
                                
                                <tr>                              					
                                    <td>维生素A，IU</td>
                                    <td>2200</td>
                                    <td>1800</td>
                                    <td>1500</td>
                                    <td>1400</td>
                                    <td>1300</td>
                                </tr>
                                <tr>                              					
                                    <td>维生素D3，IU</td>
                                    <td>220</td>
                                    <td>200</td>
                                    <td>170</td>
                                    <td>160</td>
                                    <td>150</td>
                                </tr>
                                <tr>                              					
                                    <td>维生素E，IU</td>
                                    <td>16</td>
                                    <td>11</td>
                                    <td>11</td>
                                    <td>11</td>
                                    <td>11</td>
                                </tr>
                                    <tr>                              					
                                    <td>维生素K，mg</td>
                                    <td>0.50</td>
                                    <td>0.50</td>
                                    <td>0.50</td>
                                    <td>0.50</td>
                                    <td>0.50</td>
                                </tr>
                                <tr>                              					
                                    <td>硫胺素，mg</td>
                                    <td>1.50</td>
                                    <td>1.00</td>
                                    <td>1.00</td>
                                    <td>1.00</td>
                                    <td>1.00</td>
                                </tr>
                                <tr>                              					
                                    <td>核黄素，mg</td>
                                    <td>4.00</td>
                                    <td>3.50</td>
                                    <td>2.50</td>
                                    <td>2.00</td>
                                    <td>2.00</td>
                                </tr>
                                <tr>                              					
                                    <td>泛酸，mg</td>
                                    <td>12.00</td>
                                    <td>10.00</td>
                                    <td>8.00</td>
                                    <td>7.50</td>
                                    <td>7.00</td>
                                </tr>
                                <tr>                              					
                                    <td>烟酸，mg</td>
                                    <td>20.00</td>
                                    <td>15.00</td>
                                    <td>10.00</td>
                                    <td>8.50</td>
                                    <td>7.50</td>
                                </tr>
                                <tr>                              					
                                    <td>吡哆醇，mg</td>
                                    <td>2.00</td>
                                    <td>1.50</td>
                                    <td>1.00</td>
                                    <td>1.00</td>
                                    <td>1.00</td>
                                </tr>
                                <tr>                              					
                                    <td>生物素，mg</td>
                                    <td>0.08</td>
                                    <td>0.05</td>
                                    <td>0.05</td>
                                    <td>0.05</td>
                                    <td>0.05</td>
                                </tr>
                              
                                <tr>                              					
                                    <td>叶酸，mg</td>
                                    <td>0.30</td>
                                    <td>0.30</td>
                                    <td>0.30</td>
                                    <td>0.30</td>
                                    <td>0.30</td>
                                </tr>
                                <tr>                              					
                                    <td>维生素B12，μg</td>
                                    <td>20.00</td>
                                    <td>17.50</td>
                                    <td>11.00</td>
                                    <td>8.00</td>
                                    <td>6.00</td>
                                </tr>
                                <tr>                              					
                                    <td>胆碱，g</td>
                                    <td>0.60</td>
                                    <td>0.50</td>
                                    <td>0.35</td>
                                    <td>0.30</td>
                                    <td>0.30</td>
                                </tr>
                                <tr>                              					
                                    <td>亚油酸，g</td>
                                    <td>0.10</td>
                                    <td>0.10</td>
                                    <td>0.10</td>
                                    <td>0.10</td>
                                    <td>0.10</td>
                                </tr>
                            </table>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="2、瘦肉型生长育肥猪每日每头养分需求量" name="2">
                  
                        <van-col span="24">
                            自由采食，88%干物质
                        </van-col>
                        <table  class="health_tab">
                            <tr>
                                <th style="width:100px;">体重BW，kg</th>
                                    <th>3~8</th>
                                    <th>8~20</th>
                                    <th>20~35</th>
                                    <th>35~60</th>
                                    <th>60~90</th>
                                </tr>
                                <tr>
                                    <td>平均体重Average BW，kg</td>
                                    <td>5.5</td>
                                    <td>14.0</td>
                                    <td>27.5</td>
                                    <td>47.5</td>
                                    <td>75.0</td>
                                </tr>
                                <tr>
                                    <td>日增重ADG，kg/d</td>
                                    <td>0.24</td>
                                    <td>0.44</td>
                                    <td>0.61</td>
                                    <td>0.69</td>
                                    <td>0.80</td>
                                </tr>
                                <tr>                              					
                                    <td>采食量ADFI，kg/d</td>
                                    <td>0.30</td>
                                    <td>0.74</td>
                                    <td>1.43</td>
                                    <td>1.90</td>
                                    <td>2.50</td>
                                </tr>
                                <tr>                              					
                                    <td>饲料/增重 F/G</td>
                                    <td>1.25</td>
                                    <td>1.59</td>
                                    <td>2.34</td>
                                    <td>2.75</td>
                                    <td>3.13</td>
                                </tr>
                                <tr>                              					
                                    <td>饲粮消化能含量DE，MJ/kg(kcal/kg)</td>
                                    <td>4.21(1005)</td>
                                    <td>10.06(2405)</td>
                                    <td>19.15(4575)</td>
                                    <td>25.44(6080)</td>
                                    <td>33.48(8000)</td>
                                </tr>
                                <tr>                              					
                                    <td>饲粮代谢能含量ME,MJ/kg(kcal/kg)</td>
                                    <td>4.04(965)</td>
                                    <td>9.66(2310)  </td>
                                    <td>18.39(4390)</td>
                                    <td>24.43(5835))</td>
                                    <td>32.15(7675)</td>
                                </tr>
                                <tr>                              					
                                    <td>粗蛋白质CP，%</td>
                                    <td>63</td>
                                    <td>141 </td>
                                    <td>255</td>
                                    <td>312</td>
                                    <td>363</td>
                                </tr>				
                                <tr>                              					
                                    <td colspan="6">氨基酸，g/d</td>
                                    
                                </tr>
                                <tr>                              					
                                    <td>赖氨酸Lys</td>
                                    <td>4.3</td>
                                    <td>8.6 </td>
                                    <td>12.9</td>
                                    <td>15.6</td>
                                    <td>17.5</td>
                                </tr>
                                <tr>                              					
                                    <td>蛋氨酸Met</td>
                                    <td>1.2</td>
                                    <td>2.2</td>
                                    <td>3.4</td>
                                    <td>4.2</td>
                                    <td>4.8</td>
                                </tr>					
                                <tr>                              					
                                    <td>蛋氨酸+胱氨酸Met+Cys</td>
                                    <td>2.4</td>
                                    <td>4.9</td>
                                    <td>7.3</td>
                                    <td>9.1</td>
                                    <td>10.0</td>
                                </tr>					
                                <tr>                              					
                                    <td>苏氨酸Thr</td>
                                    <td>2.8</td>
                                    <td>5.6</td>
                                    <td>8.3</td>
                                    <td>10.6</td>
                                    <td>12.0</td>
                                </tr>					
                                <tr>                              					
                                    <td>色氨酸Trp</td>
                                    <td>0.8</td>
                                    <td>1.6</td>
                                    <td>2.3</td>
                                    <td>2.9</td>
                                    <td>3.3</td>
                                </tr>					
                                <tr>                              					
                                    <td>异亮氨酸Ile</td>
                                    <td>2.4</td>
                                    <td>4.7</td>
                                    <td>6.7</td>
                                    <td>8.7</td>
                                    <td>9.8</td>
                                </tr>
                                <tr>                              					
                                    <td>亮氨酸Leu</td>
                                    <td>4.3</td>
                                    <td>8.4</td>
                                    <td>12.2</td>
                                    <td>14.8</td>
                                    <td>15.8</td>
                                </tr>
                                <tr>                              					
                                    <td>精氨酸Arg</td>
                                    <td>1.7</td>
                                    <td>3.4</td>
                                    <td>5.0</td>
                                    <td>5.7</td>
                                    <td>5.5</td>
                                </tr>	
                                <tr>                              					
                                    <td>缬氨酸Val</td>
                                    <td>2.9</td>
                                    <td>5.9</td>
                                    <td>8.7</td>
                                    <td>10.8</td>
                                    <td>11.8</td>
                                </tr>
                                <tr>                              					
                                    <td>组氨酸His</td>
                                    <td>1.4</td>
                                    <td>2.7</td>
                                    <td>4.0</td>
                                    <td>4.9</td>
                                    <td>5.5</td>
                                </tr>
                                <tr>                              					
                                    <td>苯丙氨酸Phe</td>
                                    <td>2.6</td>
                                    <td>5.1</td>
                                    <td>7.4</td>
                                    <td>9.1</td>
                                    <td>10.0</td>
                                </tr>
                                <tr>                              					
                                    <td>苯丙氨酸+酪氨酸Phe+Tyr</td>
                                    <td>4.0</td>
                                    <td>7.9</td>
                                    <td>11.7</td>
                                    <td>14.6</td>
                                    <td>16.0</td>
                                </tr>
                                <tr>                              					
                                    <td colspan="6">矿物元素，g、mg/d</td>
                                </tr>
                                <tr>                              					
                                    <td>钙Ca，%</td>
                                    <td>2.64</td>
                                    <td>5.48</td>
                                    <td>8.87</td>
                                    <td>10.45</td>
                                    <td>12.25</td>
                                </tr>
                                <tr>                              					
                                    <td>总磷，%</td>
                                    <td>2.22</td>
                                    <td>4.29</td>
                                    <td>7.58</td>
                                    <td>9.12</td>
                                    <td>10.75</td> 
                                </tr>
                                <tr>                              					
                                    <td>非植酸磷，%</td>				
                                    <td>1.62</td>
                                    <td>2.66</td>
                                    <td>3.58</td>
                                    <td>3.80</td>
                                    <td>4.25</td>
                                </tr>
                                <tr>                              					
                                    <td>钠Na，%</td>
                                    <td>0.75</td>
                                    <td>1.11</td>
                                    <td>1.72</td>
                                    <td>1.90</td>
                                    <td>2.50</td>
                                </tr>
                                <tr>                              					
                                    <td>氯Cl，%</td>
                                    <td>0.75</td>
                                    <td>1.11</td>
                                    <td>1.43</td>
                                    <td>1.71</td>
                                    <td>2.00</td>
                                </tr>
                                <tr>                              					
                                    <td>镁Mg，%</td>
                                    <td>0.12</td>
                                    <td>0.30</td>
                                    <td>0.57</td>
                                    <td>0.76</td>
                                    <td>1.00</td>
                                </tr>
                                <tr>                              					
                                    <td>钾K，%</td>
                                    <td>0.90</td>
                                    <td>1.92</td>
                                    <td>3.43</td>
                                    <td>3.99</td>
                                    <td>4.50</td>
                                </tr>
                                <tr>                              					
                                    <td>铜Cu，mg</td>
                                    <td>1.80</td>
                                    <td>4.44</td>
                                    <td>6.44</td>
                                    <td>7.60</td>
                                    <td>8.75</td>
                                </tr>
                                <tr>                              					
                                    <td>碘I，mg</td>
                                    <td>0.04</td>
                                    <td>0.10</td>
                                    <td>0.20</td>
                                    <td>0.27</td>
                                    <td>0.35</td>
                                </tr>
                                <tr>                              					
                                    <td>铁Fe，mg</td>
                                    <td>31.50</td>
                                    <td>77.70</td>  
                                    <td>100.10</td>
                                    <td>114.00</td>
                                    <td>125.00</td>
                                </tr>
                                <tr>                              					
                                    <td>锰Mn，mg</td>
                                    <td>1.20</td>
                                    <td>2.96</td>
                                    <td>4.29</td>
                                    <td>3.80</td>
                                    <td>5.00</td>
                                </tr>
                                <tr>                          				
                                    <td>硒Se，mg</td>
                                    <td>0.09</td>
                                    <td>0.22</td>
                                    <td>0.43</td>
                                    <td>0.48</td>
                                    <td>0.63</td>
                                </tr>
                                 <tr>                              					
                                    <td>锌Zn，mg</td>
                                    <td>33.00</td>
                                    <td>81.40	</td>
                                    <td>100.10</td>
                                    <td>114.00</td>
                                    <td>125.00</td>
                                </tr>
                                <tr>                              					
                                    <td colspan="6">维生素和脂肪酸，IU、g、mg或μg/d</td>
                                    
                                </tr>
                             <tr>                              					
                                <td>维生素A，IU</td>
                                <td>660</td>
                                <td>1330</td>
                                <td>2145</td>
                                <td>2660</td>
                                <td>3250</td>
                            </tr>
                            <tr>                              					
                                <td>维生素D3，IU</td>
                                <td>66</td>
                                <td>148</td>
                                <td>243</td>
                                <td>304</td>
                                <td>375</td>
                            </tr>
                            <tr>                              					
                                <td>维生素E，IU</td>
                                <td>5</td>
                                <td>8.5</td>
                                <td>16</td>
                                <td>21</td>
                                <td>28</td>
                            </tr>
                                <tr>                              					
                                <td>维生素K，mg</td>
                                <td>0.15</td>
                                <td>0.37</td>
                                <td>0.72</td>
                                <td>0.95</td>
                                <td>1.25</td>
                            </tr>
                            <tr>                              					
                                <td>硫胺素，mg</td>
                                <td>0.45</td>
                                <td>0.74</td>
                                <td>1.43</td>
                                <td>1.90</td>
                                <td>2.50</td>
                            </tr>
                            <tr>                              					
                                <td>核黄素，mg</td>
                                <td>1.20</td>
                                <td>2.59</td>
                                <td>3.58</td>
                                <td>3.80</td>
                                <td>5.00</td>
                            </tr>
                            <tr>                              					
                                <td>泛酸，mg</td>
                                <td>3.60</td>
                                <td>7.40</td>
                                <td>11.44</td>
                                <td>14.25</td>
                                <td>17.5</td>
                            </tr>
                            <tr>                              					
                                <td>烟酸，mg</td>
                                <td>6.00</td>
                                <td>11.10</td>
                                <td>14.30</td>
                                <td>16.15</td>
                                <td>18.75</td>
                            </tr>
                            <tr>                              					
                                <td>吡哆醇，mg</td>
                                <td>0.60</td>
                                <td>1.11</td>
                                <td>1.43</td>
                                <td>1.90</td>
                                <td>2.50</td>
                            </tr>
                            <tr>                              					
                                <td>生物素，mg</td>
                                <td>0.02</td>
                                <td>0.04</td>
                                <td>0.07</td>
                                <td>0.10</td>
                                <td>0.13</td>
                            </tr>
                            <tr>                              					
                                <td>叶酸，mg</td>
                                <td>0.09</td>
                                <td>0.22</td>
                                <td>0.43</td>
                                <td>0.57</td>
                                <td>0.75</td>
                            </tr>
                            <tr>                              					
                                <td>维生素B12，μg</td>
                                <td>6.00</td>
                                <td>12.95</td>
                                <td>15.73</td>
                                <td>15.20</td>
                                <td>15.00</td>
                            </tr>
                            <tr>                              					
                                <td>胆碱，g</td>
                                <td>0.18</td>
                                <td>0.37</td>
                                <td>0.50</td>
                                <td>0.57</td>
                                <td>0.75</td>
                            </tr>
                            <tr>                              					
                                <td>亚油酸，g</td>
                                <td>0.30</td>
                                <td>0.74</td>
                                <td>1.43</td>
                                <td>1.90</td>
                                <td>2.50</td>
                            </tr>
                            <tr>                              					
                                <td colspan="6"></td>
                            </tr>			
                        </table>
                    
                </van-collapse-item>
                <van-collapse-item title="3、瘦肉型妊娠母猪每千克饲粮养分含量" name="3">
                    <van-row>
                        <van-col span="24">
                             <van-col span="24">
                                88%干物质
                            </van-col>
                          
                            <table class="health_tab">
                                <tr>
                                    <th colspan="1" style="width:100px;">妊娠期</th>
                                    <th colspan="3">妊娠前期</th>
                                    <th colspan="3">妊娠后期</th>
                                </tr>
                                <tr>
                                    <td>配种体重，kg</td>
                                    <td>120~150</td>
                                    <td>150~180</td>
                                    <td>>180</td>
                                    <td>120~150</td>
                                    <td>150~180</td>
                                    <td>>180</td>
                                </tr>
                                <tr>
                                    <td>预期窝产仔数</td>
                                    <td>10</td>
                                    <td>11</td>
                                    <td>11</td>
                                    <td>10</td>
                                    <td>11</td>
                                    <td>11</td>
                                </tr>
                                <tr>
                                    <td>采食量，kg/d</td>
                                    <td>2.10</td>
                                    <td>2.10</td>
                                    <td>2.00</td>
                                    <td>2.60</td>
                                    <td>2.80</td>
                                    <td>3.00</td>
                                </tr>
                                <tr>
                                    <td>饲粮消化能含量DE，MJ/kg(kcal/kg)</td>
                                    <td>12.75(3050)</td>
                                    <td>12.35(2950)</td>
                                    <td>12.15(2950)	</td>
                                    <td>12.75(3050)</td>
                                    <td>12.55(3000)</td>
                                    <td>12.55(3000)</td>
                                </tr>
                                <tr>
                                    <td>饲粮代谢能含量ME,MJ/kg(kcal/kg)</td>
                                    <td>12.25(2930)	</td>
                                    <td>11.85(2830)</td>
                                    <td>11.65(2830)	</td>
                                    <td>12.25(2930)	</td>
                                    <td>12.05(2880)</td>
                                    <td>12.05(2880)</td>
                                </tr>
                               	<tr>
                                    <td>粗蛋白质CP，%</td>
                                    <td>13.0</td>
                                    <td>12.0</td>
                                    <td>12.0</td>
                                    <td>14.0</td>
                                    <td>13.0</td>
                                    <td>12.0</td>
                                </tr>			
                                <tr>
                                    <td>能量蛋白比DE/CP,kg%(kcal/%)</td>
                                    <td>981(235)</td>
                                    <td>1029(246)</td>
                                    <td>1013(246)</td>
                                    <td>911(218)</td>
                                    <td>965(231)</td>
                                    <td>1045(250)</td>
                                </tr>
                                <tr>
                                    <td>赖氨酸能量比Lys/DE,g/MJ(g/Mcal)</td>
                                    <td>0.42(1.74)</td>
                                    <td>0.40(1.67)</td>
                                    <td>0.38(1.58)</td>
                                    <td>0.42(1.74)</td>
                                    <td>0.41(1.70)</td>
                                    <td>0.38(1.60)</td>
                                </tr>
                                <tr>
                                    <td colspan="7">氨基酸，%</td>
                                </tr>
                                <tr>
                                    <td>赖氨酸Lys</td>
                                    <td>0.53</td>
                                    <td>0.49</td>
                                    <td>0.46</td>
                                    <td>0.53</td>
                                    <td>0.51</td>
                                    <td>0.48</td>
                                </tr>
                                <tr>
                                    <td>蛋氨酸Met</td>
                                    <td>0.14</td>
                                    <td>0.13</td>
                                    <td>0.12</td>
                                    <td>0.14</td>
                                    <td>0.13</td>
                                    <td>0.12</td>
                                </tr>
                                <tr>
                                    <td>蛋氨酸+胱氨酸Met+Cys</td>
                                    <td>0.35</td>
                                    <td>0.32</td>
                                    <td>0.31</td>
                                    <td>0.34</td>
                                    <td>0.33</td>
                                    <td>0.32</td>
                                </tr>
                                <tr>
                                    <td>苏氨酸Thr</td>
                                    <td>0.40</td>
                                    <td>0.39</td>
                                    <td>0.37</td>
                                    <td>0.40</td>
                                    <td>0.40</td>
                                    <td>0.38</td>
                                </tr>
                                <tr>
                                    <td>色氨酸Trp</td>
                                    <td>0.10</td>
                                    <td>0.09</td>
                                    <td>0.09</td>
                                    <td>0.10</td>
                                    <td>0.09</td>
                                    <td>0.09</td>
                                </tr>
                                <tr>
                                    <td>异亮氨酸Ile</td>
                                    <td>0.29</td>
                                    <td>0.28</td>
                                    <td>0.26</td>
                                    <td>0.29</td>
                                    <td>0.29</td>
                                    <td>0.27</td>
                                </tr>
                                <tr>
                                    <td>亮氨酸Leu</td>
                                    <td>0.45</td>
                                    <td>0.41</td>
                                    <td>0.37</td>
                                    <td>0.45</td>
                                    <td>0.42</td>
                                    <td>0.38</td>
                                </tr>
                                <tr>
                                    <td>精氨酸Arg</td>
                                    <td>0.06</td>
                                    <td>0.02</td>
                                    <td>0.00</td>
                                    <td>0.06</td>
                                    <td>0.02</td>
                                    <td>0.00</td>
                                </tr>  
                                <tr>
                                    <td>缬氨酸Val</td>
                                    <td>0.35</td>
                                    <td>0.32</td>
                                    <td>0.30</td>
                                    <td>0.35</td>
                                    <td>0.33</td>
                                    <td>0.31</td>
                                </tr>  
                                <tr>
                                    <td>组氨酸His</td>
                                    <td>0.17</td>
                                    <td>0.16</td>
                                    <td>0.15</td>
                                    <td>0.17</td>
                                    <td>0.17</td>
                                    <td>0.16</td>
                                </tr>
                                <tr>
                                    <td>苯丙氨酸Phe</td>
                                    <td>0.29</td>
                                    <td>0.27</td>
                                    <td>0.25</td>
                                    <td>0.29</td>
                                    <td>0.28</td>
                                    <td>0.26</td>
                                </tr>   
                                <tr>
                                    <td>苯丙氨酸+酪氨酸Phe+Tyr</td>
                                    <td>0.49</td>
                                    <td>0.45</td>
                                    <td>0.43</td>
                                    <td>0.49</td>
                                    <td>0.47</td>
                                    <td>0.44</td>
                                </tr> 	    
                                <tr>
                                    <td colspan="7">矿物元素，%或每千克饲粮含量</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">钙Ca，%</td>
                                    <td  colspan="6"> 0.68</td>
                                </tr> 	
                                <tr>
                                    <td  colspan="1">总磷，%</td>
                                    <td  colspan="6"> 0.54</td>
                                </tr> 
                                <tr>
                                    <td  colspan="1">非植酸磷，%</td>
                                    <td  colspan="6"> 0.32</td>
                                </tr> 
                                <tr>
                                    <td  colspan="1">钠Na，%</td>
                                    <td  colspan="6"> 0.14</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">氯Cl，%</td>
                                    <td  colspan="6"> 0.11</td>
                                </tr>
                               
                                <tr>
                                    <td  colspan="1">镁Mg，%</td>
                                    <td  colspan="6"> 0.04</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">钾K，%</td>
                                    <td  colspan="6"> 0.18</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">铜Cu，mg</td>
                                    <td  colspan="6"> 5.0</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">碘I，mg</td>
                                    <td  colspan="6"> 0.13</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">铁Fe，mg</td>
                                    <td  colspan="6">75.0</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">锰Mn，mg</td>
                                    <td  colspan="6">18.0</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">硒Se，mg</td>
                                    <td  colspan="6">0.14</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">锌Zn，mg</td>
                                    <td  colspan="6">45.0</td>
                                </tr>
                                <tr>
                                    <td  colspan="7">维生素和脂肪酸，%或每千克饲粮含量</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">维生素A，IU</td>
                                    <td  colspan="6">3620</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">维生素D3，IU</td>
                                    <td  colspan="6">180</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">维生素E，IU</td>
                                    <td  colspan="6">40</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">维生素K，mg</td>
                                    <td  colspan="6">0.50</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">硫胺素，mg</td>
                                    <td  colspan="6">0.90</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">核黄素，mg</td>
                                    <td  colspan="6">3.40</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">泛酸，mg</td>
                                    <td  colspan="6">11</td>
                                </tr>   
                                <tr>
                                    <td  colspan="1">烟酸，mg</td>
                                    <td  colspan="6">9.05</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">吡哆醇，mg</td>
                                    <td  colspan="6">0.90</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">生物素，mg</td>
                                    <td  colspan="6">0.19</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">叶酸，mg</td>
                                    <td  colspan="6">1.20</td>
                                </tr> 
                                <tr>
                                    <td  colspan="1">维生素B12，μg</td>
                                    <td  colspan="6">14</td>
                                </tr> 
                                 <tr>
                                    <td  colspan="1">胆碱，g</td>
                                    <td  colspan="6">1.15</td>
                                </tr> 
                                 <tr>
                                    <td  colspan="1">亚油酸，%</td>
                                    <td  colspan="6">0.10</td>
                                </tr>      
                            </table>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="4、瘦肉型泌乳母猪每千克饲粮养分含量" name="4">
                    <van-row>
                        <van-col span="24">
                             <van-col span="24">
                                88%干物质
                            </van-col>
                          
                            <table class="health_tab">
                                <tr>
                                    <th colspan="1" style="width:100px;">分娩体重，kg</th>
                                    <th colspan="2">140~180</th>
                                    <th colspan="2">180~240</th>
                                </tr>
                                <tr>
                                    <td>泌乳期体重变化，kg</td>
                                    <td>0.0</td>
                                    <td>-10.0</td>
                                    <td>-7.5</td>
                                    <td>-15</td>
                                </tr>
                                <tr>
                                    <td>哺乳窝仔数，头</td>
                                    <td>9</td>
                                    <td>9</td>
                                    <td>10</td>
                                    <td>10</td>
                                </tr>
                                <tr>
                                    <td>采食量，kg/d</td>
                                    <td>5.25</td>
                                    <td>4.65</td>
                                    <td>5.65</td>
                                    <td>5.20</td>
                                </tr>
                                <tr>
                                    <td>饲粮消化能含量DE，MJ/kg(kcal/kg)</td>
                                    <td>13.80(3300)</td>
                                    <td>13.80(3300)</td>
                                    <td>13.80(3300)</td>
                                    <td>13.80(3300)</td>
                                </tr>
                                <tr>
                                    <td>饲粮代谢能含量ME</td>
                                    <td>13.25(3170)</td>
                                    <td>13.25(3170)</td>
                                    <td>13.25(3170)</td>
                                    <td>13.25(3170)</td>
                                </tr>
                                <tr>
                                    <td>粗蛋白质CP，%</td>
                                    <td>17.5</td>
                                    <td>18.0</td>
                                    <td>18.0</td>
                                    <td>18.5</td>
                                </tr>
                                <tr>
                                    <td>能量蛋白比DE/CP,kg%(kcal/%</td>
                                    <td>789(189)</td>
                                    <td>767(183)</td>
                                    <td>767(183)</td>
                                    <td>767(178)</td>
                                </tr>
                                <tr>
                                    <td>赖氨酸能量比Lys/DE,g/MJ(g/Mcal)</td>
                                    <td>0.64(2.67)</td>
                                    <td>0.67(2.82)</td>
                                    <td>0.66(2.76)</td>
                                    <td>0.68(2.85)</td>
                                </tr>
                               
                                <tr>
                                    <td colspan="5">氨基酸，%</td>
                                </tr>
                                <tr>
                                    <td>赖氨酸Lys</td>
                                    <td>0.88</td>
                                    <td>0.93</td>
                                    <td>0.91</td>
                                    <td>0.94</td>
                                </tr>
                                <tr>
                                    <td>蛋氨酸Met</td>
                                    <td>0.22</td>
                                    <td>0.24</td>
                                    <td>0.23</td>
                                    <td>0.24</td>
                                </tr>
                                <tr>
                                    <td>蛋氨酸+胱氨酸Met+Cys</td>
                                    <td>0.42</td>
                                    <td>0.46</td>
                                    <td>0.44</td>
                                    <td>0.45</td>
                                </tr>   
                                <tr>
                                    <td>苏氨酸Thr</td>
                                    <td>0.56</td>
                                    <td>0.59</td>
                                    <td>0.58</td>
                                    <td>0.60</td>
                                </tr>  
                                <tr>
                                    <td>色氨酸Trp</td>
                                    <td>0.16</td>
                                    <td>0.17</td>
                                    <td>0.17</td>
                                    <td>0.18</td>
                                </tr>   
                                <tr>
                                    <td>异亮氨酸Ile</td>
                                    <td>0.49</td>
                                    <td>0.52</td>
                                    <td>0.51</td>
                                    <td>0.53</td>
                                </tr>   
                                <tr>
                                    <td>亮氨酸Leu</td>
                                    <td>0.95</td>
                                    <td>1.01</td>
                                    <td>0.98</td>
                                    <td>1.02</td>
                                </tr>     
                                <tr>
                                    <td>精氨酸Arg</td>
                                    <td>0.48</td>
                                    <td>0.48</td>
                                    <td>0.47</td>
                                    <td>0.47</td>
                                </tr>    
                                <tr>
                                    <td>缬氨酸Val</td>
                                    <td>0.74</td>
                                    <td>0.79</td>
                                    <td>0.77</td>
                                    <td>0.81</td>
                                </tr>
                                <tr>
                                    <td>组氨酸His</td>
                                    <td>0.34</td>
                                    <td>0.36</td>
                                    <td>0.35</td>
                                    <td>0.37</td>
                                </tr>         
                                <tr>
                                    <td>苯丙氨酸Phe</td>
                                    <td>0.47</td>
                                    <td>0.50</td>
                                    <td>0.48</td>
                                    <td>0.50</td>
                                </tr>      
                                <tr>
                                    <td>苯丙氨酸+酪氨酸Phe+Tyr</td>
                                    <td>0.97</td>
                                    <td>1.03</td>
                                    <td>1.00</td>
                                    <td>1.04</td>
                                </tr>        
                                  
                                <tr>
                                    <td  colspan="5">矿物元素，%或每千克饲粮含量</td>
                                    
                                </tr> 	
                                   

                                <tr>
                                    <td  colspan="1">钙Ca，%</td>
                                    <td  colspan="4"> 0.77</td>
                                </tr> 	
                                <tr>
                                    <td  colspan="1">总磷，%</td>
                                    <td  colspan="4"> 0.62</td>
                                </tr> 	
                                <tr>
                                    <td  colspan="1">非植酸磷，%</td>
                                    <td  colspan="4"> 0.36</td>
                                </tr> 	
                                <tr>
                                    <td  colspan="1">钠Na，%</td>
                                    <td  colspan="4"> 0.21</td>
                                </tr> 	
                                <tr>
                                    <td  colspan="1">氯Cl，%</td>
                                    <td  colspan="4"> 0.16</td>
                                </tr> 	
                                <tr>
                                    <td  colspan="1">镁Mg，%</td>
                                    <td  colspan="4"> 0.04</td>
                                </tr> 	
                                <tr>
                                    <td  colspan="1">钾K，%</td>
                                    <td  colspan="4"> 0.21</td>
                                </tr> 	
                                <tr>
                                    <td  colspan="1">铜Cu，mg</td>
                                    <td  colspan="4"> 5.0</td>
                                </tr>                               
                                <tr>
                                    <td  colspan="1">碘I，mg</td>
                                    <td  colspan="4"> 0.14</td>
                                </tr>       
                                <tr>
                                    <td  colspan="1">铁Fe，mg</td>
                                    <td  colspan="4"> 80.0</td>
                                </tr>       
                                <tr>
                                    <td  colspan="1">锰Mn，mg</td>
                                    <td  colspan="4"> 20.5</td>
                                </tr>
                                 
                                <tr>
                                    <td  colspan="1">硒Se，mg</td>
                                    <td  colspan="4"> 0.15</td>
                                </tr>          
                                <tr>
                                    <td  colspan="1">锌Zn，mg</td>
                                    <td  colspan="4"> 51.0</td>
                                </tr> 
                                <tr>
                                    <td  colspan="5">维生素和脂肪酸，%或每千克饲粮含量</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">维生素A，IU</td>
                                    <td  colspan="4"> 2050</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">维生素D3，IU</td>
                                    <td  colspan="4"> 205</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">维生素E，IU</td>
                                    <td  colspan="4"> 45</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">维生素K，mg</td>
                                    <td  colspan="4"> 0.5</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">硫胺素，mg</td>
                                    <td  colspan="4"> 1.00</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">核黄素，mg</td>
                                    <td  colspan="4"> 3.85</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">泛酸，mg</td>
                                    <td  colspan="4"> 12</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">烟酸，mg</td>
                                    <td  colspan="4"> 10.25</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">吡哆醇，mg</td>
                                    <td  colspan="4"> 1.00</td>
                                </tr> 	 	 	
                                <tr>
                                    <td  colspan="1">生物素，mg</td>
                                    <td  colspan="4"> 0.21</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">叶酸，mg</td>
                                    <td  colspan="4"> 1.35</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">维生素B12，μg</td>
                                    <td  colspan="4"> 1.35</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">胆碱，g</td>
                                    <td  colspan="4"> 1.00</td>
                                </tr>
                                <tr>
                                    <td  colspan="1">亚油酸，%</td>
                                    <td  colspan="4"> 0.10</td>
                                </tr>
                            </table>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="5、配种公猪每千克饲粮和每日每头养分需要量" name="5">
                    <van-row>
                        <van-col span="24">
                             <van-col span="24">
                                88%干物质
                            </van-col>
                          
                            <table class="health_tab">
                                <tr>
                                    <th>饲粮消化能含量DE，MJ/kg(kcal/kg)</th>
                                    <th>12.95（3100）</th>
                                    <th>12.95（3100）</th>
                                </tr>
                                <tr>
                                    <td>饲粮代谢能含量ME，MJ/kg(kcal/kg)</td>
                                    <td> 12.45（2975）</td>
                                    <td> 12.45（975）</td>
                                </tr>
                                <tr>
                                    <td>消化能摄入量DE，MJ/kg(kcal/kg)</td>
                                    <td> 21.70（6820）</td>
                                    <td> 21.70（6820）</td>
                                </tr>
                                <tr>
                                    <td>代谢能摄入量ME，MJ/kg(kcal/kg)</td>
                                    <td> 20.85（6545）</td>
                                    <td> 20.85（6545）</td>
                                </tr>
                                <tr>
                                    <td> 采食量ADFI,kg/d</td>
                                    <td> 2.2</td>
                                    <td> 2.2</td>
                                </tr>
                                <tr>
                                    <td> 粗蛋白质CP，%</td>
                                    <td> 13.50</td>
                                    <td> 13.50</td>
                                </tr>
                                <tr>
                                    <td> 能量蛋白比DE/CP,kg%(kcal/%)</td>
                                    <td> 959（230）</td>
                                    <td> 959（230）</td>
                                </tr>
                                <tr>
                                    <td> 赖氨酸能量比Lys/DE,g/MJ(g/Mcal)</td>
                                    <td> 0.42（1.78）</td>
                                    <td> 0.42（1.78）</td>
                                </tr>

                                <tr>
                                    <td  colspan="3">需要量</td>
                                </tr>
                                <tr>
                                    <td> 氨基酸</td>
                                    <td>每千克饲粮中含量%</td>
                                    <td>每日需要量g</td>
                                </tr>
                                <tr>
                                    <td> 赖氨酸Lys</td>
                                    <td>0.55</td>
                                    <td>12.1</td>
                                </tr>
                                <tr>
                                    <td> 蛋氨酸Met</td>
                                    <td>0.15</td>
                                    <td>3.31</td>
                                </tr>
                                <tr>
                                    <td> 蛋氨酸+胱氨酸Met+Cys</td>
                                    <td>0.38</td>
                                    <td>8.4</td>
                                </tr>
                                <tr>
                                    <td>苏氨酸Thr</td>
                                    <td>0.46</td>
                                    <td>10.1</td>
                                </tr>
                                <tr>
                                    <td>色氨酸Trp</td>
                                    <td>0.11</td>
                                    <td>2.4</td>
                                </tr>
                                <tr>
                                    <td>异亮氨酸Ile</td>
                                    <td>0.32</td>
                                    <td>7.0</td>
                                </tr>
                                <tr>
                                    <td>亮氨酸Leu</td>
                                    <td>0.47</td>
                                    <td>10.3</td>
                                </tr>
                                <tr>
                                    <td>精氨酸Arg</td>
                                    <td>0.00</td>
                                    <td>0.0</td>
                                </tr>
                                <tr>
                                    <td>缬氨酸Val</td>
                                    <td>0.36</td>
                                    <td>7.9</td>
                                </tr>
                                <tr>
                                    <td>组氨酸His</td>
                                    <td>0.17</td>
                                    <td>3.7</td>
                                </tr>
                                <tr>
                                    <td>苯丙氨酸Phe</td>
                                    <td>0.30</td>
                                    <td>6.6</td>
                                </tr>
                                <tr>
                                    <td>苯丙氨酸+酪氨酸Phe+Tyr</td>
                                    <td>0.52</td>
                                    <td>11.4</td>
                                </tr>
                                <tr>
                                    <td colspan="3">矿物元素</td>
                                </tr>
                                <tr>
                                    <td>钙Ca</td>
                                    <td>0.70%</td>
                                    <td>15.4mg</td>
                                </tr>
                                <tr>
                                    <td>总磷</td>
                                    <td>0.55%</td>
                                    <td>12.1mg</td>
                                </tr>
                                <tr>
                                    <td>非植酸磷</td>
                                    <td>0.32%</td>
                                    <td>7.04mg</td>
                                </tr>
                                <tr>
                                    <td>钠Na</td>
                                    <td>0.14%</td>
                                    <td>3.08mg</td>
                                </tr>
                                <tr>
                                    <td>氯Cl</td>
                                    <td>0.11%</td>
                                    <td>2.42mg</td>
                                </tr>
                                <tr>
                                    <td>镁Mg</td>
                                    <td>0.04%</td>
                                    <td>0.88mg</td>
                                </tr>
                                <tr>
                                    <td>钾K</td>
                                    <td>0.20%</td>
                                    <td>4.40mg</td>
                                </tr>
                                <tr>
                                    <td>铜Cu</td>
                                    <td>5mg</td>
                                    <td>11.0mg</td>
                                </tr>
                                <tr>
                                    <td>碘I</td>
                                    <td>0.15mg</td>
                                    <td>0.33mg</td>
                                </tr>
                                <tr>
                                    <td>铁Fe</td>
                                    <td>80mg</td>
                                    <td>176.00mg</td>
                                </tr>
                                <tr>
                                    <td>锰Mn</td>
                                    <td>20mg</td>
                                    <td>44.00mg</td>
                                </tr>
                                <tr>
                                    <td>硒Se</td>
                                    <td>0.15mg</td>
                                    <td>0.33mg</td>
                                </tr>
                                <tr>
                                    <td>锌Zn</td>
                                    <td>75mg</td>
                                    <td>165mg</td>
                                </tr>
                                <tr>
                                    <td colspan="3">维生素和脂肪酸</td>
                                </tr>
                                <tr>
                                    <td>维生素A</td>
                                    <td>4000 IU</td>
                                    <td>8800 IU</td>
                                </tr>
                                <tr>
                                    <td>维生素D3</td>
                                    <td>220 IU</td>
                                    <td>485 IU</td>
                                </tr>
                                <tr>
                                    <td>维生素E</td>
                                    <td>45 IU</td>
                                    <td>100 IU</td>
                                </tr>
                                <tr>
                                    <td>维生素K</td>
                                    <td>0.50 mg</td>
                                    <td>1.10 mg</td>
                                </tr>
                                <tr>
                                    <td>硫胺素</td>
                                    <td>1.0 mg</td>
                                    <td>2.20 mg</td>
                                </tr>
                                <tr>
                                    <td>核黄素</td>
                                    <td>3.5 mg</td>
                                    <td>7.70 mg</td>
                                </tr>
                                <tr>
                                    <td>泛酸</td>
                                    <td>12 mg</td>
                                    <td>26.4 mg</td>
                                </tr>
                                <tr>
                                    <td>烟酸</td>
                                    <td>10 mg</td>
                                    <td>22 mg</td>
                                </tr>
                                <tr>
                                    <td>吡哆醇</td>
                                    <td>1.0 mg</td>
                                    <td>2.20 mg</td>
                                </tr>
                                <tr>
                                    <td>生物素</td>
                                    <td>0.20 mg</td>
                                    <td>0.44 mg</td>
                                </tr>
                                <tr>
                                    <td>叶酸</td>
                                    <td>1.30 mg</td>
                                    <td>2.86 mg</td>
                                </tr>
                                <tr>
                                    <td>维生素B12</td>
                                    <td>15μg</td>
                                    <td>33μg</td>
                                </tr>
                                <tr>
                                    <td>胆碱</td>
                                    <td>1.25 g</td>
                                    <td>2.75 g</td>
                                </tr>
                                <tr>
                                    <td>亚油酸</td>
                                    <td>0.1%</td>
                                    <td>2.2%</td>
                                </tr>
                            </table>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="6、肉脂型生长育肥猪每千克饲粮养分含量" name="6">
                    <van-row>
                        <van-col span="24">
                             <van-col span="24">
                                自由采食，88%干物质
                            </van-col>
                          
                            <table class="health_tab">
                                <tr>
                                    <th style="width:100px;">体重，kg</th>
                                    <th>5~8</th>
                                    <th>8~15</th>
                                    <th>15~30</th>
                                    <th>30~60</th>
                                    <th>60~90</th>
                                </tr>
                                <tr>
                                    <td>日增重ADG，kg/d</td>
                                    <td> 0.22</td>
                                    <td> 0.38</td>
                                    <td> 0.50</td>
                                    <td> 0.60</td>
                                    <td> 0.70</td>
                                </tr>
                                <tr>
                                    <td>采食量ADFI,kg/d</td>
                                    <td> 0.40</td>
                                    <td> 0.87</td>
                                    <td> 1.36</td>
                                    <td> 2.02</td>
                                    <td> 2.94</td>
                                </tr>
                                <tr>
                                    <td>饲料转化率，F/G</td>
                                    <td> 1.80</td>
                                    <td> 2.30</td>
                                    <td> 2.73</td>
                                    <td> 3.35</td>
                                    <td> 4.20</td>
                                </tr>
                                <tr>
                                    <td>饲粮消化能含量DE，MJ/kg(kcal/kg)</td>
                                    <td> 13.80(3300)</td>
                                    <td> 13.60(3250)</td>
                                    <td> 12.95(3100)</td>
                                    <td> 12.95(3100)</td>
                                    <td> 12.95(3100)</td>
                                </tr>
                                <tr>
                                    <td>粗蛋白质CP，%</td>
                                    <td> 21.0</td>
                                    <td> 18.2</td>
                                    <td> 16.0</td>
                                    <td> 14.0</td>
                                    <td> 13.0</td>
                                </tr>
                                <tr>
                                    <td>能量蛋白比DE/CP,kg%(kcal/%)</td>
                                    <td> 657(157)</td>
                                    <td> 747(179)</td>
                                    <td> 810(194)</td>
                                    <td> 925(221)</td>
                                    <td> 996(238)</td>
                                </tr>
                                <tr>
                                    
                                    <td>能量蛋白比DE/CP,kg%(kcal/%)</td>
                                    <td> 657(157)</td>
                                    <td> 747(179)</td>
                                    <td> 810(194)</td>
                                    <td> 925(221)</td>
                                    <td> 996(238)</td>
                                </tr>
                                <tr>
                                    <td>赖氨酸能量比Lys/DE,g/MJ(g/Mcal)</td>
                                    <td> 0.97(4.06)</td>
                                    <td> 0.77(3.23)</td>
                                    <td> 0.66(2.75)</td>
                                    <td> 0.53(2.23)</td>
                                    <td> 0.46(1.94)</td>
                                </tr>
                            
                                <tr>
                                    <td colspan="6">氨基酸，%</td>
                                </tr>
                                <tr>
                                    <td>赖氨酸Lys</td>
                                    <td> 1.34</td>
                                    <td> 1.05</td>
                                    <td> 0.85</td>
                                    <td> 0.69</td>
                                    <td> 0.60</td>
                                </tr>
                                <tr>
                                    <td>蛋氨酸+胱氨酸Met+Cys</td>
                                    <td> 0.65</td>
                                    <td> 0.53</td>
                                    <td> 0.43</td>
                                    <td> 0.38</td>
                                    <td> 0.34</td>
                                </tr>
                                <tr>
                                    <td>苏氨酸Thr</td>
                                    <td> 0.77</td>
                                    <td> 0.62</td>
                                    <td> 0.50</td>
                                    <td> 0.45</td>
                                    <td> 0.39</td>
                                </tr>
                                <tr>
                                    <td>色氨酸Trp</td>
                                    <td> 0.19</td>
                                    <td> 0.15</td>
                                    <td> 0.12</td>
                                    <td> 0.11</td>
                                    <td> 0.11</td>
                                </tr>
                                <tr>
                                    <td>异亮氨酸Ile</td>
                                    <td> 0.73</td>
                                    <td> 0.59</td>
                                    <td> 0.47</td>
                                    <td> 0.43</td>
                                    <td> 0.37</td>
                                </tr>
                                <tr>
                                    <td colspan="6">矿物元素，%或每千克饲粮含量</td>
                                </tr>
                                <tr>
                                    <td>钙Ca，%</td>
                                    <td> 0.86</td>
                                    <td> 0.74</td>
                                    <td> 0.64</td>
                                    <td> 0.55</td>
                                    <td> 0.46</td>
                                </tr>
                                <tr>
                                    <td>总磷，%</td>
                                    <td> 0.67</td>
                                    <td> 0.60</td>
                                    <td> 0.55</td>
                                    <td> 0.46</td>
                                    <td> 0.37</td>
                                </tr>
                                <tr>
                                    <td>非植酸磷，%</td>
                                    <td> 0.42</td>
                                    <td> 0.32</td>
                                    <td> 0.29</td>
                                    <td> 0.21</td>
                                    <td> 0.14</td>
                                </tr>
                                <tr>
                                    <td>钠Na，%</td>
                                    <td> 0.20</td>
                                    <td> 0.15</td>
                                    <td> 0.09</td>
                                    <td> 0.09</td>
                                    <td> 0.09</td>
                                </tr>
                                <tr>
                                    <td>氯Cl，%</td>
                                    <td> 0.20</td>
                                    <td> 0.15</td>
                                    <td> 0.07</td>
                                    <td> 0.07</td>
                                    <td> 0.07</td>
                                </tr>
                                <tr>
                                    <td>镁Mg，%</td>
                                    <td> 0.04</td>
                                    <td> 0.04</td>
                                    <td> 0.04</td>
                                    <td> 0.04</td>
                                    <td> 0.04</td>
                                </tr>
                                <tr>
                                    <td>钾K，%</td>
                                    <td> 0.29</td>
                                    <td> 0.26</td>
                                    <td> 0.24</td>
                                    <td> 0.21</td>
                                    <td> 0.16</td>
                                </tr>
                                <tr>
                                    <td>铜Cu，mg</td>
                                    <td> 6.00</td>
                                    <td> 5.5</td>
                                    <td> 4.6</td>
                                    <td> 3.7</td>
                                    <td> 3.0</td>
                                </tr>
                                <tr>
                                    <td>碘I，mg</td>
                                    <td> 100</td>
                                    <td> 92</td>
                                    <td> 74</td>
                                    <td> 55</td>
                                    <td> 37</td>
                                </tr>
                                <tr>
                                    <td>铁Fe，mg</td>
                                    <td> 0.13</td>
                                    <td> 0.13</td>
                                    <td> 0.13</td>
                                    <td> 0.13</td>
                                    <td> 0.13</td>
                                </tr>
                                <tr>
                                    <td>锰Mn，mg</td>
                                    <td> 4.00</td>
                                    <td> 3.00</td>
                                    <td> 3.00</td>
                                    <td> 2.00</td>
                                    <td> 2.00</td>
                                </tr>
                                <tr>
                                    <td>硒Se，mg</td>
                                    <td> 0.30</td>
                                    <td> 0.27</td>
                                    <td> 0.23</td>
                                    <td> 0.14</td>
                                    <td> 0.09</td>
                                </tr>
                                <tr>
                                    <td>锌Zn，mg</td>
                                    <td> 100</td>
                                    <td> 90</td>
                                    <td> 75</td>
                                    <td> 55</td>
                                    <td> 45</td>
                                </tr>
                                <tr>
                                    <td colspan="6">维生素和脂肪酸，%或每千克饲粮含量</td>
                                </tr>
                                <tr>
                                    <td>维生素A，IU</td>
                                    <td> 2100</td>
                                    <td> 2000</td>
                                    <td> 1600</td>
                                    <td> 1200</td>
                                    <td> 1200</td>
                                </tr>
                                <tr>
                                    <td>维生素D3，IU</td>
                                    <td> 210</td>
                                    <td> 200</td>
                                    <td> 180</td>
                                    <td> 140</td>
                                    <td> 140</td>
                                </tr>
                                
                                <tr>
                                    <td>维生素E，IU</td>
                                    <td> 15</td>
                                    <td> 15</td>
                                    <td> 10</td>
                                    <td> 10</td>
                                    <td> 10</td>
                                </tr>
                                <tr>
                                    <td>维生素K，mg</td>
                                    <td> 0.50</td>
                                    <td> 0.20</td>
                                    <td> 0.50</td>
                                    <td> 0.50</td>
                                    <td> 0.50</td>
                                </tr>
                                <tr>
                                    <td>硫胺素，mg</td>
                                    <td> 1.50</td>
                                    <td> 1.00</td>
                                    <td> 1.00</td>
                                    <td> 1.00</td>
                                    <td> 1.00</td>
                                </tr>
                                <tr>
                                    <td>核黄素，mg</td>
                                    <td> 4.00</td>
                                    <td> 3.5</td>
                                    <td> 3.0</td>
                                    <td> 2.0</td>
                                    <td> 2.0</td>
                                </tr>
                                <tr>
                                    <td>核黄素，mg</td>
                                    <td> 4.00</td>
                                    <td> 3.5</td>
                                    <td> 3.0</td>
                                    <td> 2.0</td>
                                    <td> 2.0</td>
                                </tr>
                                <tr>
                                    <td>泛酸，mg</td>
                                    <td> 12.00</td>
                                    <td> 10.00</td>
                                    <td> 8.00</td>
                                    <td> 7.00</td>
                                    <td> 6.00</td>
                                </tr>
                                <tr>
                                    <td>烟酸，mg</td>
                                    <td> 20.00</td>
                                    <td> 14.00</td>
                                    <td> 12.0</td>
                                    <td> 9.00</td>
                                    <td> 6.50</td>
                                </tr>
                               <tr>
                                    <td>吡哆醇，mg</td>
                                    <td> 2.00</td>
                                    <td> 1.50</td>
                                    <td> 1.50</td>
                                    <td> 1.00</td>
                                    <td> 1.00</td>
                                </tr>
                                <tr>
                                    <td>生物素，mg</td>
                                    <td> 0.08</td>
                                    <td> 0.05</td>
                                    <td> 0.05</td>
                                    <td> 0.05</td>
                                    <td> 0.05</td>
                                </tr>
                                
                                <tr>
                                    <td>叶酸，mg</td>
                                    <td> 0.30</td>
                                    <td> 0.30</td>
                                    <td> 0.30</td>
                                    <td> 0.30</td>
                                    <td> 0.30</td>
                                </tr>
                                <tr>
                                    <td>维生素B12，μg</td>
                                    <td>20.00 </td>
                                    <td> 16.50</td>
                                    <td> 14.50</td>
                                    <td> 10.00</td>
                                    <td> 5.00</td>
                                </tr>
                                 <tr>
                                    <td>胆碱，g</td>
                                    <td> 0.50</td>
                                    <td> 0.40</td>
                                    <td> 0.30</td>
                                    <td> 0.30</td>
                                    <td> 0.30</td>
                                </tr>
                                <tr>
                                    <td>亚油酸，</td>
                                    <td> 0.10</td>
                                    <td> 0.10</td>
                                    <td> 0.10</td>
                                    <td> 0.10</td>
                                    <td> 0.10</td>
                                </tr>
                            </table>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="7、肉脂型生长育肥猪每日每头养分含量" name="7">
                    <van-row>
                        <van-col span="24">
                             <van-col span="24">
                                自由采食，88%干物质
                            </van-col>
                          
                            <table class="health_tab">
                                <tr>
                                    <th style="width:100px;">体重，kg</th>
                                    <th>5~8</th>
                                    <th>8~15</th>
                                    <th>15~30</th>
                                    <th>30~60</th>
                                    <th>60~90</th>
                                </tr>
                                <tr>
                                    <td>日增重ADG，kg/d</td>
                                    <td> 0.22</td>
                                    <td> 0.38</td>
                                    <td> 0.50</td>
                                    <td> 0.60</td>
                                    <td> 0.70</td>
                                </tr>
                                <tr>
                                    <td>采食量ADFI,kg/d</td>
                                    <td> 0.40</td>
                                    <td> 0.87</td>
                                    <td> 1.36</td>
                                    <td> 2.02</td>
                                    <td> 2.94</td>
                                </tr>
                                <tr>
                                    <td>饲料转化率，F/G</td>
                                    <td> 1.80</td>
                                    <td> 2.30</td>
                                    <td> 2.73</td>
                                    <td> 3.35</td>
                                    <td> 4.20</td>
                                </tr>
                                <tr>
                                    <td>饲粮消化能含量DE，MJ/kg(kcal/kg)</td>
                                    <td> 13.80(3300)</td>
                                    <td> 13.60(3250)</td>
                                    <td> 12.95(3100)</td>
                                    <td> 12.95(3100)</td>
                                    <td> 12.95(3100)</td>
                                </tr>
                                <tr>
                                    <td>粗蛋白质CP，%</td>
                                    <td> 84.0</td>
                                    <td> 158.3</td>
                                    <td> 217.6</td>
                                    <td> 282.8</td>
                                    <td> 382.2</td>
                                </tr>
                                <tr>
                                    <td colspan="6">氨基酸，%</td>
                                </tr>
                                <tr>
                                    <td>赖氨酸Lys</td>
                                    <td> 5.4</td>
                                    <td> 9.1</td>
                                    <td> 11.6</td>
                                    <td> 13.9</td>
                                    <td> 17.6</td>
                                </tr>
                                <tr>
                                    <td>蛋氨酸+胱氨酸Met+Cys</td>
                                    <td> 2.6</td>
                                    <td> 4.6</td>
                                    <td> 5.8</td>
                                    <td> 7.7</td>
                                    <td> 10.0</td>
                                </tr>
                                <tr>
                                    <td>苏氨酸Thr</td>
                                    <td> 3.1</td>
                                    <td> 5.4</td>
                                    <td> 6.8</td>
                                    <td> 9.1</td>
                                    <td> 11.5</td>
                                </tr>
                                <tr>
                                    <td>色氨酸Trp</td>
                                    <td> 0.8</td>
                                    <td> 1.3</td>
                                    <td> 1.6</td>
                                    <td> 2.2</td>
                                    <td> 3.2</td>
                                </tr>
                                <tr>
                                    <td>异亮氨酸Ile</td>
                                    <td> 2.9</td>
                                    <td> 5.1</td>
                                    <td> 6.4</td>
                                    <td> 8.7</td>
                                    <td> 10.9</td>
                                </tr>
                                <tr>
                                    <td colspan="6">矿物元素，%或mg/d</td>
                                </tr>
                                <tr>
                                    <td>钙Ca，%</td>
                                    <td> 3.4</td>
                                    <td> 6.4</td>
                                    <td> 8.7</td>
                                    <td> 11.1</td>
                                    <td> 13.5</td>
                                </tr>
                                <tr>
                                    <td>总磷，%</td>
                                    <td> 2.7</td>
                                    <td>5.2 </td>
                                    <td>7.5</td>
                                    <td>9.3 </td>
                                    <td> 10.9</td>
                                </tr>
                                <tr>
                                    <td>非植酸磷，%</td>
                                    <td> 1.7</td>
                                    <td>2.8</td>
                                    <td>3.9 </td>
                                    <td>4.2 </td>
                                    <td>4.1 </td>
                                </tr>
                                <tr>
                                    <td>钠Na，%</td>
                                    <td>0.8</td>
                                    <td>1.3</td>
                                    <td>1.2</td>
                                    <td>1.8</td>
                                    <td>2.6</td>
                                </tr>
                                <tr>
                                    <td>氯Cl，%</td>
                                    <td>0.8 </td>
                                    <td>1.3</td>
                                    <td>1.0 </td>
                                    <td>1.8 </td>
                                    <td>2.6 </td>
                                </tr>
                                <tr>
                                    <td>镁Mg，%</td>
                                    <td>0.2 </td>
                                    <td>0.3 </td>
                                    <td>0.5 </td>
                                    <td>0.8 </td>
                                    <td>1.2 </td>
                                </tr>
                                <tr>
                                    <td>钾K，%</td>
                                    <td>1.2 </td>
                                    <td>2.3 </td>
                                    <td>3.3 </td>
                                    <td>4.2 </td>
                                    <td>4.7 </td>
                                </tr>
                                <tr>
                                    <td>铜Cu，mg</td>
                                    <td>2.40</td>
                                    <td> 4.79</td>
                                    <td> 6.12</td>
                                    <td> 8.08</td>
                                    <td> 8.82</td>
                                </tr>
                                <tr>
                                    <td>碘I，mg</td>
                                    <td> 40.00</td>
                                    <td> 80.04</td>
                                    <td> 100.64</td>
                                    <td> 111.10</td>
                                    <td> 108.78</td>
                                </tr>
                                <tr>
                                    <td>铁Fe，mg</td>
                                    <td> 0.05</td>
                                    <td> 0.11</td>
                                    <td> 0.18</td>
                                    <td> 0.26</td>
                                    <td> 0.38</td>
                                </tr>
                                <tr>
                                    <td>锰Mn，mg</td>
                                    <td> 1.60</td>
                                    <td> 2.61</td>
                                    <td> 4.08 </td>
                                    <td> 4.04 </td>
                                    <td> 5.88 </td>
                                </tr>
                                <tr>
                                    <td>硒Se，mg</td>
                                    <td> 0.12</td>
                                    <td> 0.22</td>
                                    <td> 0.34</td>
                                    <td> 0.30</td>
                                    <td> 0.29</td>
                                </tr>
                                <tr>
                                    <td>锌Zn，mg</td>
                                    <td> 40.0</td>
                                    <td> 78.3</td>
                                    <td> 102.0</td>
                                    <td> 111.1</td>
                                    <td> 132.3</td>
                                </tr>
                                <tr>
                                    <td colspan="6">维生素和脂肪酸，%或每千克饲粮含量</td>
                                </tr>
                                <tr>
                                    <td>维生素A，IU</td>
                                    <td> 840.0</td>
                                    <td> 1740.0</td>
                                    <td> 2176.0</td>
                                    <td> 2424.0</td>
                                    <td> 3528.0</td>
                                </tr>
                                <tr>
                                    <td>维生素D3，IU</td>
                                    <td> 84.0</td>
                                    <td> 174.0</td>
                                    <td> 244.8</td>
                                    <td> 282.8</td>
                                    <td> 411.6</td>
                                </tr>
                               
                                <tr>
                                    <td>维生素E，IU</td>
                                    <td> 6.0</td>
                                    <td> 13.1</td>
                                    <td> 13.6</td>
                                    <td> 20.2</td>
                                    <td> 29.4</td>
                                </tr>
                                <tr>
                                    <td>维生素K，mg</td>
                                    <td> 0.2</td>
                                    <td> 0.4</td>
                                    <td> 0.7</td>
                                    <td> 1.0</td>
                                    <td> 1.5</td>
                                </tr>
                                <tr>
                                    <td>硫胺素，mg</td>
                                    <td> 0.6</td>
                                    <td> 0.9</td>
                                    <td> 1.4</td>
                                    <td> 2.0</td>
                                    <td> 2.9</td>
                                </tr>
                                <tr>
                                    <td>核黄素，mg</td>
                                    <td> 1.6</td>
                                    <td> 3.0</td>
                                    <td> 4.1</td>
                                    <td> 4.0</td>
                                    <td> 5.9</td>
                                </tr>
                               
                               
                                
                                <tr>
                                    <td>泛酸，mg</td>
                                    <td> 4.8</td>
                                    <td> 8.7</td>
                                    <td> 10.9</td>
                                    <td> 14.1</td>
                                    <td> 17.6</td>
                                </tr>
                                <tr>
                                    <td>烟酸，mg</td>
                                    <td> 8.0</td>
                                    <td> 12.2</td>
                                    <td> 16.3</td>
                                    <td> 18.2</td>
                                    <td> 19.1</td>
                                </tr>
                               <tr>
                                    <td>吡哆醇，mg</td>
                                    <td> 0.8</td>
                                    <td> 1.3</td>
                                    <td> 2.0</td>
                                    <td> 2.0</td>
                                    <td> 2.9</td>
                                </tr>
                                <tr>
                                    <td>生物素，mg</td>
                                    <td> 0.0</td>
                                    <td> 0.0</td>
                                    <td> 0.1</td>
                                    <td> 0.1</td>
                                    <td> 0.1</td>
                                </tr>
                                
                                <tr>
                                    <td>叶酸，mg</td>
                                    <td> 0.1</td>
                                    <td> 0.3</td>
                                    <td> 0.4</td>
                                    <td> 0.6</td>
                                    <td> 0.9</td>
                                </tr>
                                <tr>
                                    <td>维生素B12，μg</td>
                                    <td>8.0</td>
                                    <td>14.4</td>
                                    <td>19.7</td>
                                    <td>20.2</td>
                                    <td>14.7</td>
                                </tr>
                                 <tr>
                                    <td>胆碱，g</td>
                                    <td> 0.2</td>
                                    <td> 0.3</td>
                                    <td> 0.4</td>
                                    <td> 0.6</td>
                                    <td> 0.7</td>
                                </tr>
                                <tr>
                                    <td>亚油酸，</td>
                                    <td> 0.4</td>
                                    <td> 0.9</td>
                                    <td> 1.4</td>
                                    <td> 2.0</td>
                                    <td> 2.9</td>
                                </tr>
                            </table>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="8、肉脂型生长育肥猪每千克饲粮养分含量" name="8">
                    <van-row>
                        <van-col span="24">
                             <van-col span="24">
                                自由采食，88%干物质
                            </van-col>
                          
                            <table class="health_tab">
                                <tr>
                                    <th style="width:100px;">体重，kg</th>
                                    <th>8~15</th>
                                    <th>15~30</th>
                                    <th>30~60</th>
                                    <th>60~90</th>
                                </tr>
                                <tr>
                                    <td>日增重ADG，kg/d</td>
                                    <td> 0.34</td>
                                    <td> 0.45</td>
                                    <td> 0.55</td>
                                    <td> 0.65</td>
                                </tr>
                                <tr>
                                    <td>采食量ADFI,kg/d</td>
                                    <td> 0.87</td>
                                    <td> 1.30</td>
                                    <td> 1.96</td>
                                    <td> 2.89</td>
                                </tr>
                                <tr>
                                    <td>饲料转化率，F/G</td>
                                    <td> 2.55</td>
                                    <td> 2.90</td>
                                    <td> 3.55</td>
                                    <td> 4.45</td>
                                </tr>
                                <tr>
                                    <td>饲粮消化能含量DE，MJ/kg(kcal/kg)</td>
                                    <td> 13.30(3180)</td>
                                    <td> 12.25(2930)</td>
                                    <td> 12.25(2930)</td>
                                    <td> 12.25(2930)</td>
                                </tr>
                                <tr>
                                    <td>粗蛋白质CP，%</td>
                                    <td> 17.5</td>
                                    <td>16.0</td>
                                    <td>14.0</td>
                                    <td>13.0</td>
                                </tr>
                                <tr>
                                    <td>能量蛋白比DE/CP,kg%(kcal/%)</td>
                                    <td> 760(182)</td>
                                    <td>760(183)</td>
                                    <td>875(209)</td>
                                    <td>942(225)</td>
                                </tr>
                                <tr>
                                    <td>赖氨酸能量比Lys/DE,g/MJ(g/Mcal)</td>
                                    <td>0.74(3.11)</td>
                                    <td>0.65(2.73)</td>
                                    <td>0.53(2.22)</td>
                                    <td>0.46(1.91)</td>
                                </tr>
                                <tr>
                                    <td colspan="5">氨基酸，%</td>
                                </tr>
                                <tr>
                                    <td>赖氨酸Lys</td>
                                    <td> 0.99</td>
                                    <td> 0.80</td>
                                    <td> 0.65</td>
                                    <td> 0.56</td>
                                    
                                </tr>
                                <tr>
                                    <td>蛋氨酸+胱氨酸Met+Cys</td>
                                    <td> 0.56</td>
                                    <td> 0.40</td>
                                    <td> 0.35</td>
                                    <td> 0.32</td>
                                </tr>
                                <tr>
                                    <td>苏氨酸Thr</td>
                                    <td> 0.64</td>
                                    <td> 0.48</td>
                                    <td> 0.41</td>
                                    <td> 0.37</td>
                                </tr>
                                <tr>
                                    <td>色氨酸Trp</td>
                                    <td> 0.18</td>
                                    <td> 0.12</td>
                                    <td> 0.11</td>
                                    <td> 0.10</td>
                                </tr>
                                <tr>
                                    <td>异亮氨酸Ile</td>
                                    <td> 0.54</td>
                                    <td> 0.45</td>
                                    <td> 0.40</td>
                                    <td> 0.34</td>
                                </tr>
                                <tr>
                                    <td colspan="5">矿物元素，%或每千克饲料含量</td>
                                </tr>
                                <tr>
                                    <td>钙Ca，%</td>
                                    <td> 0.72</td>
                                    <td> 0.62</td>
                                    <td> 0.53</td>
                                    <td> 0.44</td>
                                  
                                </tr>
                                <tr>
                                    <td>总磷，%</td>
                                    <td>0.58</td>
                                    <td>0.53</td>
                                    <td>0.44</td>
                                    <td>0.35</td>
                                </tr>
                                <tr>
                                    <td>非植酸磷，%</td>
                                    <td>0.31</td>
                                    <td>0.27</td>
                                    <td>0.20</td>
                                    <td>0.13</td>
                                </tr>
                                <tr>
                                    <td>钠Na，%</td>
                                    <td>0.14</td>
                                    <td>0.09</td>
                                    <td>0.09</td>
                                    <td>0.09</td>
                                </tr>
                                <tr>
                                    <td>氯Cl，%</td>
                                    <td>0.14 </td>
                                    <td>0.07</td>
                                    <td>0.07</td>
                                    <td>0.07</td>
                                </tr>
                                <tr>
                                    <td>镁Mg，%</td>
                                    <td>0.05 </td>
                                    <td>0.04 </td>
                                    <td>0.04 </td>
                                    <td>0.04 </td>
                                </tr>
                                <tr>
                                    <td>钾K，%</td>
                                    <td>0.25 </td>
                                    <td>0.23</td>
                                    <td>0.20 </td>
                                    <td>0.15 </td>
                                </tr>
                                <tr>
                                    <td>铜Cu，mg</td>
                                    <td>5.00</td>
                                    <td>4.00</td>
                                    <td>3.00</td>
                                    <td>3.00</td>
                                </tr>
                                <tr>
                                    <td>碘I，mg</td>
                                    <td>90.00</td>
                                    <td>70.00</td>
                                    <td>55.00</td>
                                    <td>35.00</td>
                                </tr>
                                <tr>
                                    <td>铁Fe，mg</td>
                                    <td> 0.12</td>
                                    <td> 0.12</td>
                                    <td> 0.12</td>
                                    <td> 0.12</td>
                                </tr>
                                <tr>
                                    <td>锰Mn，mg</td>
                                    <td> 3.00</td>
                                    <td> 2.50</td>
                                    <td> 2.00 </td>
                                    <td> 2.00 </td>
                                </tr>
                                <tr>
                                    <td>硒Se，mg</td>
                                    <td> 0.26</td>
                                    <td> 0.22</td>
                                    <td> 0.13</td>
                                    <td> 0.09</td>
                                </tr>
                                <tr>
                                    <td>锌Zn，mg</td>
                                    <td> 90</td>
                                    <td> 70.00</td>
                                    <td> 53.00</td>
                                    <td> 44.00</td>
                                </tr>
                                <tr>
                                    <td colspan="5">维生素和脂肪酸，%或每千克饲料含量</td>
                                </tr>
                                 <tr>
                                    <td>维生素A，IU</td>
                                    <td> 1900</td>
                                    <td> 1550</td>
                                    <td> 1150</td>
                                    <td> 1150</td>
                                </tr>
                                <tr>
                                    <td>维生素D3，IU</td>
                                    <td> 190</td>
                                    <td> 170</td>
                                    <td> 130</td>
                                    <td> 130</td>
                                </tr>
                               
                                <tr>
                                    <td>维生素E，IU</td>
                                    <td> 15</td>
                                    <td> 10</td>
                                    <td> 10</td>
                                    <td> 10</td>
                                </tr>
                                <tr>
                                    <td>维生素K，mg</td>
                                    <td> 0.45</td>
                                    <td> 0.45</td>
                                    <td> 0.45</td>
                                    <td> 0.45</td>
                                </tr>
                                <tr>
                                    <td>硫胺素，mg</td>
                                    <td> 1.00</td>
                                    <td> 1.00</td>
                                    <td> 1.00</td>
                                    <td> 1.00</td>
                                </tr>
                                <tr>
                                    <td>核黄素，mg</td>
                                    <td> 3.00</td>
                                    <td> 2.50</td>
                                    <td> 2.00</td>
                                    <td> 2.00</td>
                                </tr>
                                <tr>
                                    <td>泛酸，mg</td>
                                    <td> 10.00</td>
                                    <td> 8.00</td>
                                    <td> 7.00</td>
                                    <td> 6.00</td>
                                </tr>
                                <tr>
                                    <td>烟酸，mg</td>
                                    <td> 14.00</td>
                                    <td> 12.00</td>
                                    <td> 9.00</td>
                                    <td> 6.50</td>
                                </tr>
                               <tr>
                                    <td>吡哆醇，mg</td>
                                    <td> 1.50</td>
                                    <td> 1.50</td>
                                    <td> 1.00</td>
                                    <td> 1.00</td>
                                </tr>
                                <tr>
                                    <td>生物素，mg</td>
                                    <td> 0.05</td>
                                    <td> 0.04</td>
                                    <td> 0.04</td>
                                    <td> 0.04</td>
                                </tr>
                                
                                <tr>
                                    <td>叶酸，mg</td>
                                    <td> 0.30</td>
                                    <td> 0.30</td>
                                    <td> 0.30</td>
                                    <td> 0.30</td>
                                </tr>
                                <tr>
                                    <td>维生素B12，μg</td>
                                    <td>15.00</td>
                                    <td>13.00</td>
                                    <td>10.00</td>
                                    <td>5.00</td>
                                </tr>
                                 <tr>
                                    <td>胆碱，g</td>
                                    <td> 0.40</td>
                                    <td> 0.30</td>
                                    <td> 0.30</td>
                                    <td> 0.30</td>
                                </tr>
                                <tr>
                                    <td>亚油酸，</td>
                                    <td> 0.10</td>
                                    <td> 0.10</td>
                                    <td> 0.10</td>
                                    <td> 0.10</td>
                                </tr>
                            </table>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="9、肉脂型生长育肥猪每日每头养分需要量" name="9">
                    <van-row>
                        <van-col span="24">
                             <van-col span="24">
                                自由采食，88%干物质
                            </van-col>
                          
                            <table class="health_tab">
                                <tr>
                                    <th style="width:100px;">体重，kg</th>
                                    <th>8~15</th>
                                    <th>15~30</th>
                                    <th>30~60</th>
                                    <th>60~90</th>
                                </tr>
                                <tr>
                                    <td>日增重ADG，kg/d</td>
                                    <td> 0.34</td>
                                    <td> 0.45</td>
                                    <td> 0.55</td>
                                    <td> 0.65</td>
                                </tr>
                                <tr>
                                    <td>采食量ADFI,kg/d</td>
                                    <td> 0.87</td>
                                    <td> 1.30</td>
                                    <td> 1.96</td>
                                    <td> 2.89</td>
                                </tr>
                                <tr>
                                    <td>饲料转化率，F/G</td>
                                    <td> 2.55</td>
                                    <td> 2.90</td>
                                    <td> 3.55</td>
                                    <td> 4.45</td>
                                </tr>
                                <tr>
                                    <td>饲粮消化能含量DE，MJ/kg(kcal/kg)</td>
                                    <td> 13.30(3180)</td>
                                    <td> 12.25(2930)</td>
                                    <td> 12.25(2930)</td>
                                    <td> 12.25(2930)</td>
                                </tr>
                                <tr>
                                    <td>粗蛋白质CP，g/d</td>
                                    <td>152.3</td>
                                    <td>208.0</td>
                                    <td>274.4</td>
                                    <td>375.7</td>
                                </tr>
                                
                                <tr>
                                    <td colspan="5">氨基酸，%</td>
                                </tr>
                                <tr>
                                    <td>赖氨酸Lys</td>
                                    <td> 8.6</td>
                                    <td> 10.4</td>
                                    <td> 12.7</td>
                                    <td> 16.2</td>
                                    
                                </tr>
                                <tr>
                                    <td>蛋氨酸+胱氨酸Met+Cys</td>
                                    <td> 4.9</td>
                                    <td> 5.2</td>
                                    <td> 6.9</td>
                                    <td> 9.2</td>
                                </tr>
                                <tr>
                                    <td>苏氨酸Thr</td>
                                    <td> 5.6</td>
                                    <td> 6.2</td>
                                    <td> 8.0</td>
                                    <td> 10.7</td>
                                </tr>
                                <tr>
                                    <td>色氨酸Trp</td>
                                    <td> 1.6</td>
                                    <td> 1.6</td>
                                    <td> 2.2</td>
                                    <td> 2.9</td>
                                </tr>
                                <tr>
                                    <td>异亮氨酸Ile</td>
                                    <td> 4.7</td>
                                    <td> 5.9</td>
                                    <td> 7.8</td>
                                    <td> 9.8</td>
                                </tr>
                                <tr>
                                    <td colspan="5">矿物元素，%或每千克饲料含量</td>
                                </tr>
                                <tr>
                                    <td>钙Ca，%</td>
                                    <td> 6.3</td>
                                    <td> 8.1</td>
                                    <td> 10.4</td>
                                    <td> 10.7</td>
                                  
                                </tr>
                                <tr>
                                    <td>总磷，%</td>
                                    <td>5.0</td>
                                    <td>6.9</td>
                                    <td>8.6</td>
                                    <td>10.1</td>
                                </tr>
                                <tr>
                                    <td>非植酸磷，%</td>
                                    <td>2.7</td>
                                    <td>3.5</td>
                                    <td>3.9</td>
                                    <td>3.8</td>
                                </tr>
                                <tr>
                                    <td>钠Na，%</td>
                                    <td>1.2</td>
                                    <td>1.2</td>
                                    <td>1.8</td>
                                    <td>2.6</td>
                                </tr>
                                <tr>
                                    <td>氯Cl，%</td>
                                    <td>1.2 </td>
                                    <td>0.9</td>
                                    <td>1.4</td>
                                    <td>2.0</td>
                                </tr>
                                <tr>
                                    <td>镁Mg，%</td>
                                    <td>0.3 </td>
                                    <td>0.5 </td>
                                    <td>0.8 </td>
                                    <td>1.2 </td>
                                </tr>
                                <tr>
                                    <td>钾K，%</td>
                                    <td>2.2 </td>
                                    <td>3.0</td>
                                    <td>3.9 </td>
                                    <td>4.3</td>
                                </tr>
                                <tr>
                                    <td>铜Cu，mg</td>
                                    <td>4.4</td>
                                    <td>5.2</td>
                                    <td>5.9</td>
                                    <td>8.7</td>
                                </tr>
                                <tr>
                                    <td>碘I，mg</td>
                                    <td>78.3</td>
                                    <td>91.0</td>
                                    <td>107.8</td>
                                    <td>101.2</td>
                                </tr>
                                <tr>
                                    <td>铁Fe，mg</td>
                                    <td> 0.1</td>
                                    <td> 0.2</td>
                                    <td> 0.2</td>
                                    <td> 0.3</td>
                                </tr>
                                <tr>
                                    <td>锰Mn，mg</td>
                                    <td> 2.6</td>
                                    <td> 3.3</td>
                                    <td> 3.9 </td>
                                    <td> 5.8</td>
                                </tr>
                                <tr>
                                    <td>硒Se，mg</td>
                                    <td> 0.2</td>
                                    <td> 0.3</td>
                                    <td> 0.3</td>
                                    <td> 0.3</td>
                                </tr>
                                <tr>
                                    <td>锌Zn，mg</td>
                                    <td> 78.3</td>
                                    <td> 91.0</td>
                                    <td> 103.9</td>
                                    <td> 127.2</td>
                                </tr>
                                <tr>
                                    <td colspan="5">维生素和脂肪酸，%或每千克饲料含量</td>
                                </tr>
                                 <tr>
                                    <td>维生素A，IU</td>
                                    <td> 1653</td>
                                    <td> 2015</td>
                                    <td> 2254</td>
                                    <td> 3324</td>
                                </tr>
                                <tr>
                                    <td>维生素D3，IU</td>
                                    <td> 165</td>
                                    <td> 221</td>
                                    <td> 255</td>
                                    <td> 376</td>
                                </tr>
                               
                                <tr>
                                    <td>维生素E，IU</td>
                                    <td> 13.1</td>
                                    <td> 13.0</td>
                                    <td> 19.6</td>
                                    <td> 28.9</td>
                                </tr>
                                <tr>
                                    <td>维生素K，mg</td>
                                    <td> 0.4</td>
                                    <td> 0.6</td>
                                    <td> 0.9</td>
                                    <td> 1.3</td>
                                </tr>
                                <tr>
                                    <td>硫胺素，mg</td>
                                    <td> 0.9</td>
                                    <td> 1.3</td>
                                    <td> 2.0</td>
                                    <td> 2.9</td>
                                </tr>
                                <tr>
                                    <td>核黄素，mg</td>
                                    <td> 2.6</td>
                                    <td> 3.3</td>
                                    <td> 3.9</td>
                                    <td> 5.8</td>
                                </tr>
                                <tr>
                                    <td>泛酸，mg</td>
                                    <td> 8.7</td>
                                    <td> 10.4</td>
                                    <td> 13.7</td>
                                    <td> 17.3</td>
                                </tr>
                                <tr>
                                    <td>烟酸，mg</td>
                                    <td> 12.16</td>
                                    <td> 15.6</td>
                                    <td> 17.6</td>
                                    <td> 18.79</td>
                                </tr>
                               <tr>
                                    <td>吡哆醇，mg</td>
                                    <td> 1.3</td>
                                    <td> 2.0</td>
                                    <td> 2.0</td>
                                    <td> 2.9</td>
                                </tr>
                                <tr>
                                    <td>生物素，mg</td>
                                    <td> 0.0</td>
                                    <td> 0.1</td>
                                    <td> 0.1</td>
                                    <td> 0.1</td>
                                </tr>
                                
                                <tr>
                                    <td>叶酸，mg</td>
                                    <td> 0.3</td>
                                    <td> 0.4</td>
                                    <td> 0.6</td>
                                    <td> 0.9</td>
                                </tr>
                                <tr>
                                    <td>维生素B12，μg</td>
                                    <td>13.1</td>
                                    <td>16.9</td>
                                    <td>19.6</td>
                                    <td>14.5</td>
                                </tr>
                                 <tr>
                                    <td>胆碱，g</td>
                                    <td> 0.3</td>
                                    <td> 0.4</td>
                                    <td> 0.6</td>
                                    <td> 0.9</td>
                                </tr>
                                <tr>
                                    <td>亚油酸，</td>
                                    <td> 0.9</td>
                                    <td> 1.3</td>
                                    <td> 2.0</td>
                                    <td> 2.9</td>
                                </tr>
                            </table>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="10、肉脂型生长育肥猪每千克饲粮养分含量" name="10">
                    <van-row>
                        <van-col span="24">
                             <van-col span="24">
                                自由采食，88%干物质
                            </van-col>
                          
                            <table class="health_tab">
                                <tr>
                                    <th style="width:100px;">体重，kg</th>
                                    <th>15~30</th>
                                    <th>30~60</th>
                                    <th>60~90</th>
                                </tr>
                                <tr>
                                    <td>日增重ADG，kg/d</td>
                                    <td> 0.40</td>
                                    <td> 0.50</td>
                                    <td> 0.59</td>
                                </tr>
                                <tr>
                                    <td>采食量ADFI,kg/d</td>
                                    <td> 1.28</td>
                                    <td> 1.95</td>
                                    <td> 2.92</td>
                                </tr>
                                <tr>
                                    <td>饲料转化率，F/G</td>
                                    <td> 3.20</td>
                                    <td> 3.90</td>
                                    <td> 4.95</td>
                                </tr>
                                <tr>
                                    <td>饲粮消化能含量DE，MJ/kg(kcal/kg)</td>
                                    <td> 11.70(2800)</td>
                                    <td> 11.70(2800)</td>
                                    <td> 11.70(2800)</td>
                                </tr>
                                <tr>
                                    <td>粗蛋白质CP，%</td>
                                    <td>15.0</td>
                                    <td>14.0</td>
                                    <td>13.0</td>
                                </tr>
                                <tr>
                                    <td>能量蛋白比DE/CP,kg%(kcal/%)</td>
                                    <td>780(187)</td>
                                    <td>835(200)</td>
                                    <td>900(215)</td>
                                </tr>
                                <tr>
                                    <td>赖氨酸能量比Lys/DE,g/MJ(g/Mcal)</td>
                                    <td>0.67(2.79)</td>
                                    <td>0.50(2.11)</td>
                                    <td>0.43(1.79)</td>
                                </tr>
                                <tr>
                                    <td colspan="4">氨基酸，%</td>
                                </tr>
                                <tr>
                                    <td>赖氨酸Lys</td>
                                    <td> 0.78</td>
                                    <td> 0.59</td>
                                    <td> 0.42</td>
                                </tr>
                                <tr>
                                    <td>蛋氨酸+胱氨酸Met+Cys</td>
                                    <td> 0.40</td>
                                    <td> 0.31</td>
                                    <td> 0.28</td>
                                </tr>
                                <tr>
                                    <td>苏氨酸Thr</td>
                                    <td> 0.46</td>
                                    <td> 0.38</td>
                                    <td> 0.13</td>
                                </tr>
                                <tr>
                                    <td>色氨酸Trp</td>
                                    <td> 0.11</td>
                                    <td> 0.10</td>
                                    <td> 0.09</td>
                                </tr>
                                <tr>
                                    <td>异亮氨酸Ile</td>
                                    <td> 0.44</td>
                                    <td> 0.36</td>
                                    <td> 0.31</td>
                                </tr>
                                <tr>
                                    <td colspan="4">矿物元素，%或每千克饲粮含量</td>
                                </tr>
                                <tr>
                                    <td>钙Ca，%</td>
                                    <td> 0.59</td>
                                    <td> 0.50</td>
                                    <td> 0.42</td>
                                </tr>
                                <tr>
                                    <td>总磷，%</td>
                                    <td>0.50</td>
                                    <td>0.42</td>
                                    <td>0.34</td>
                                </tr>
                                <tr>
                                    <td>非植酸磷，%</td>
                                    <td>0.27</td>
                                    <td>0.19</td>
                                    <td>0.13</td>
                                </tr>
                                <tr>
                                    <td>钠Na，%</td>
                                    <td>0.08</td>
                                    <td>0.08</td>
                                    <td>0.08</td>
                                </tr>
                                <tr>
                                    <td>氯Cl，%</td>
                                    <td>0.07 </td>
                                    <td>0.07</td>
                                    <td>0.07</td>
                                </tr>
                                <tr>
                                    <td>镁Mg，%</td>
                                    <td>0.03 </td>
                                    <td>0.03</td>
                                    <td>0.03</td>
                                </tr>
                                <tr>
                                    <td>钾K，%</td>
                                    <td>0.22 </td>
                                    <td>0.19</td>
                                    <td>0.14</td>

                                </tr>
                                <tr>
                                    <td>铜Cu，mg</td>
                                    <td>4.00</td>
                                    <td>3.00</td>
                                    <td>3.00</td>
                                </tr>
                                <tr>
                                    <td>碘I，mg</td>
                                    <td>70.00</td>
                                    <td>50.00</td>
                                    <td>35.0</td>
                                </tr>
                                <tr>
                                    <td>铁Fe，mg</td>
                                    <td> 0.12</td>
                                    <td> 0.12</td>
                                    <td> 0.12</td>
                                </tr>
                                <tr>
                                    <td>锰Mn，mg</td>
                                    <td> 3.00</td>
                                    <td> 2.00</td>
                                    <td> 2.00</td>
                                </tr>
                                <tr>
                                    <td>硒Se，mg</td>
                                    <td> 0.21</td>
                                    <td> 0.13</td>
                                    <td> 0.08</td>
                                </tr>
                                <tr>
                                    <td>锌Zn，mg</td>
                                    <td> 70.00</td>
                                    <td> 50.00</td>
                                    <td> 40.00</td>
                                </tr>
                                <tr>
                                    <td colspan="4">维生素和脂肪酸，%或每千克饲粮含量</td>
                                </tr>
                                 <tr>
                                    <td>维生素A，IU</td>
                                    <td> 1470</td>
                                    <td> 1090</td>
                                    <td> 1090</td>
                                </tr>
                                <tr>
                                    <td>维生素D3，IU</td>
                                    <td> 168</td>
                                    <td> 126</td>
                                    <td> 126</td>
                                </tr>
                               
                                <tr>
                                    <td>维生素E，IU</td>
                                    <td> 9</td>
                                    <td> 9</td>
                                    <td> 9</td>
                                </tr>
                                <tr>
                                    <td>维生素K，mg</td>
                                    <td> 0.4</td>
                                    <td> 0.4</td>
                                    <td> 0.4</td>
                                </tr>
                                <tr>
                                    <td>硫胺素，mg</td>
                                    <td> 1.0</td>
                                    <td> 1.00</td>
                                    <td> 1.00</td>
                                </tr>
                                <tr>
                                    <td>核黄素，mg</td>
                                    <td> 2.50</td>
                                    <td> 2.00</td>
                                    <td> 2.00</td>
                                </tr>
                                <tr>
                                    <td>泛酸，mg</td>
                                    <td> 8.00</td>
                                    <td> 7.00</td>
                                    <td> 6.00</td>
                                </tr>
                                <tr>
                                    <td>烟酸，mg</td>
                                    <td> 12.00</td>
                                    <td> 9.00</td>
                                    <td> 6.50</td>
                                </tr>
                               <tr>
                                    <td>吡哆醇，mg</td>
                                    <td> 1.50</td>
                                    <td> 1.00</td>
                                    <td> 1.00</td>
                                </tr>
                                <tr>
                                    <td>生物素，mg</td>
                                    <td> 0.04</td>
                                    <td> 0.04</td>
                                    <td> 0.04</td>
                                </tr>
                                
                                <tr>
                                    <td>叶酸，mg</td>
                                    <td> 0.25</td>
                                    <td> 0.25</td>
                                    <td> 0.25</td>
                                </tr>
                                <tr>
                                    <td>维生素B12，μg</td>
                                    <td>12.00</td>
                                    <td>10.00</td>
                                    <td>5.00</td>
                                </tr>
                                 <tr>
                                    <td>胆碱，g</td>
                                    <td> 0.34</td>
                                    <td> 0.25</td>
                                    <td> 0.25</td>
                                </tr>
                                <tr>
                                    <td>亚油酸，</td>
                                    <td> 0.10</td>
                                    <td> 0.10</td>
                                    <td> 0.10</td>
                                </tr>
                            </table>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="11、肉脂型生长育肥猪每日每头养分需要量" name="11">
                    <van-row>
                        <van-col span="24">
                             <van-col span="24">
                                自由采食，88%干物质
                            </van-col>
                          
                            <table class="health_tab">
                                <tr>
                                    <th style="width:100px;">体重，kg</th>
                                    <th>15~30</th>
                                    <th>30~60</th>
                                    <th>60~90</th>
                                </tr>
                                <tr>
                                    <td>日增重ADG，kg/d</td>
                                    <td> 0.40</td>
                                    <td> 0.50</td>
                                    <td> 0.59</td>
                                </tr>
                                <tr>
                                    <td>采食量ADFI,kg/d</td>
                                    <td> 1.28</td>
                                    <td> 1.95</td>
                                    <td> 2.92</td>
                                </tr>
                                <tr>
                                    <td>饲料转化率，F/G</td>
                                    <td> 3.20</td>
                                    <td> 3.90</td>
                                    <td> 4.95</td>
                                </tr>
                                <tr>
                                    <td>饲粮消化能含量DE，MJ/kg(kcal/kg)</td>
                                    <td> 11.70(2800)</td>
                                    <td> 11.70(2800)</td>
                                    <td> 11.70(2800)</td>
                                </tr>
                                <tr>
                                    <td>粗蛋白质CP，%</td>
                                    <td>192.0</td>
                                    <td>273.0</td>
                                    <td>379.6</td>
                                </tr>
                                <tr>
                                    <td colspan="4">氨基酸，%</td>
                                </tr>
                                <tr>
                                    <td>赖氨酸Lys</td>
                                    <td> 10.0</td>
                                    <td> 11.5</td>
                                    <td> 14.6</td>
                                </tr>
                                <tr>
                                    <td>蛋氨酸+胱氨酸Met+Cys</td>
                                    <td> 5.1</td>
                                    <td> 6.0</td>
                                    <td> 8.2</td>
                                </tr>
                                <tr>
                                    <td>苏氨酸Thr</td>
                                    <td> 5.9</td>
                                    <td> 7.4</td>
                                    <td> 9.6</td>
                                </tr>
                                <tr>
                                    <td>色氨酸Trp</td>
                                    <td> 1.4</td>
                                    <td> 2.0</td>
                                    <td> 2.6</td>
                                </tr>
                                <tr>
                                    <td>异亮氨酸Ile</td>
                                    <td> 5.6</td>
                                    <td> 7.0</td>
                                    <td> 9.1</td>
                                </tr>
                                <tr>
                                    <td colspan="4">矿物元素，g或mg/d</td>
                                </tr>
                                <tr>
                                    <td>钙Ca，%</td>
                                    <td> 7.6</td>
                                    <td> 9.8</td>
                                    <td> 12.3</td>
                                </tr>
                                <tr>
                                    <td>总磷，%</td>
                                    <td>6.4</td>
                                    <td>8.2</td>
                                    <td>9.9</td>
                                </tr>
                                <tr>
                                    <td>非植酸磷，%</td>
                                    <td>3.5</td>
                                    <td>3.7</td>
                                    <td>3.8</td>
                                </tr>
                                <tr>
                                    <td>钠Na，%</td>
                                    <td>1.0</td>
                                    <td>1.6</td>
                                    <td>2.3</td>
                                </tr>
                                <tr>
                                    <td>氯Cl，%</td>
                                    <td>0.9 </td>
                                    <td>1.4</td>
                                    <td>2.0</td>
                                </tr>
                                <tr>
                                    <td>镁Mg，%</td>
                                    <td>0.4 </td>
                                    <td>0.6</td>
                                    <td>0.9</td>
                                </tr>
                                <tr>
                                    <td>钾K，%</td>
                                    <td>2.8 </td>
                                    <td>3.7</td>
                                    <td>4.4</td>

                                </tr>
                                <tr>
                                    <td>铜Cu，mg</td>
                                    <td>5.1</td>
                                    <td>5.9</td>
                                    <td>8.8</td>
                                </tr>
                                <tr>
                                    <td>碘I，mg</td>
                                    <td>89.6</td>
                                    <td>97.5</td>
                                    <td>102.2</td>
                                </tr>
                                <tr>
                                    <td>铁Fe，mg</td>
                                    <td> 0.2</td>
                                    <td> 0.2</td>
                                    <td> 0.4</td>
                                </tr>
                                <tr>
                                    <td>锰Mn，mg</td>
                                    <td> 3.8</td>
                                    <td> 3.9</td>
                                    <td> 5.8</td>
                                </tr>
                                <tr>
                                    <td>硒Se，mg</td>
                                    <td> 0.3</td>
                                    <td> 0.3</td>
                                    <td> 0.3</td>
                                </tr>
                                <tr>
                                    <td>锌Zn，mg</td>
                                    <td> 89.6</td>
                                    <td> 97.5</td>
                                    <td> 116.8</td>
                                </tr>
                                <tr>
                                    <td colspan="4">维生素和脂肪酸，IU、mg或μg/d</td>
                                </tr>
                                 <tr>
                                    <td>维生素A，IU</td>
                                    <td> 1856.0</td>
                                    <td> 2145.0</td>
                                    <td> 3212.0</td>
                                </tr>
                                <tr>
                                    <td>维生素D3，IU</td>
                                    <td> 217.6</td>
                                    <td> 243.8</td>
                                    <td> 365.0</td>
                                </tr>
                               
                                <tr>
                                    <td>维生素E，IU</td>
                                    <td> 12.8</td>
                                    <td> 19.5</td>
                                    <td> 29.2</td>
                                </tr>
                                <tr>
                                    <td>维生素K，mg</td>
                                    <td> 0.5</td>
                                    <td> 0.8</td>
                                    <td> 1.2</td>
                                </tr>
                                <tr>
                                    <td>硫胺素，mg</td>
                                    <td> 1.3</td>
                                    <td> 2.0</td>
                                    <td> 2.9</td>
                                </tr>
                                <tr>
                                    <td>核黄素，mg</td>
                                    <td> 3.2</td>
                                    <td> 3.9</td>
                                    <td> 5.8</td>
                                </tr>
                                <tr>
                                    <td>泛酸，mg</td>
                                    <td> 10.2</td>
                                    <td> 13.7</td>
                                    <td> 17.5</td>
                                </tr>
                                <tr>
                                    <td>烟酸，mg</td>
                                    <td> 15.36</td>
                                    <td> 17.55</td>
                                    <td> 18.98</td>
                                </tr>
                               <tr>
                                    <td>吡哆醇，mg</td>
                                    <td> 1.9</td>
                                    <td> 2.0</td>
                                    <td> 2.9</td>
                                </tr>
                                <tr>
                                    <td>生物素，mg</td>
                                    <td> 0.1</td>
                                    <td> 0.1</td>
                                    <td> 0.1</td>
                                </tr>
                                
                                <tr>
                                    <td>叶酸，mg</td>
                                    <td> 0.3</td>
                                    <td> 0.5</td>
                                    <td> 0.7</td>
                                </tr>
                                <tr>
                                    <td>维生素B12，μg</td>
                                    <td>15.4</td>
                                    <td>19.5</td>
                                    <td>14.6</td>
                                </tr>
                                 <tr>
                                    <td>胆碱，g</td>
                                    <td> 0.4</td>
                                    <td> 0.5</td>
                                    <td> 0.7</td>
                                </tr>
                                <tr>
                                    <td>亚油酸，</td>
                                    <td> 1.3</td>
                                    <td> 2.0</td>
                                    <td> 2.9</td>
                                </tr>
                            </table>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="12、肉脂型妊娠、哺乳母猪每千克饲粮养分含量" name="12">
                    <van-row>
                        <van-col span="24">
                             <van-col span="24">
                                88%干物质
                            </van-col>
                          
                            <table class="health_tab">
                                <tr>
                                    <th style="width:100px;"></th>
                                    <th>妊娠母猪</th>
                                    <th>泌乳母猪</th>
                                 
                                </tr>
                                <tr>
                                    <td>采食量ADFI,kg/d</td>
                                    <td> 2.10</td>
                                    <td> 5.10</td>
                                </tr>
                                <tr>
                                    <td>饲粮消化能含量DE，MJ/kg(kcal/kg)</td>
                                    <td> 11.70(2800)</td>
                                    <td> 13.60（3250）</td>
                                </tr>
                                <tr>
                                    <td>粗蛋白质CP，%</td>
                                    <td>13.0</td>
                                    <td>17.5</td>
                                </tr>
                                <tr>
                                    <td>能量蛋白比DE/CP,kg%(kcal/%)</td>
                                    <td>900（215）</td>
                                    <td>777（186）</td>
                                </tr>
                                <tr>
                                    <td>赖氨酸能量比Lys/DE,g/MJ(g/Mcal)</td>
                                    <td>0.37（1.54）</td>
                                    <td>0.58（2.43）</td>
                                </tr>
                                <tr>
                                    <td colspan="3">氨基酸，%</td>
                                </tr>
                                <tr>
                                    <td>赖氨酸Lys</td>
                                    <td> 0.43</td>
                                    <td> 0.79</td>
                                </tr>
                                <tr>
                                    <td>蛋氨酸+胱氨酸Met+Cys</td>
                                    <td> 0.30</td>
                                    <td> 0.40</td>
                                </tr>
                                <tr>
                                    <td>苏氨酸Thr</td>
                                    <td> 0.35</td>
                                    <td> 0.52</td>
                                </tr>
                                <tr>
                                    <td>色氨酸Trp</td>
                                    <td> 0.08</td>
                                    <td> 0.14</td>
                                </tr>
                                <tr>
                                    <td>异亮氨酸Ile</td>
                                    <td> 0.25</td>
                                    <td> 0.45</td>
                                </tr>
                                <tr>
                                    <td colspan="3">矿物元素，%或每千克饲粮含量</td>
                                </tr>
                                <tr>
                                    <td>钙Ca，%</td>
                                    <td> 0.62</td>
                                    <td> 0.72</td>
                                </tr>
                                <tr>
                                    <td>总磷，%</td>
                                    <td>0.50</td>
                                    <td>0.58</td>
                                </tr>
                                <tr>
                                    <td>非植酸磷，%</td>
                                    <td>0.30</td>
                                    <td>0.34</td>
                                </tr>
                                <tr>
                                    <td>钠Na，%</td>
                                    <td>0.12</td>
                                    <td>0.20</td>
                                </tr>
                                <tr>
                                    <td>氯Cl，%</td>
                                    <td>0.10 </td>
                                    <td>0.16</td>
                                </tr>
                                <tr>
                                    <td>镁Mg，%</td>
                                    <td>0.04</td>
                                    <td>0.04</td>
                                </tr>
                                <tr>
                                    <td>钾K，%</td>
                                    <td>0.16 </td>
                                    <td>0.20</td>

                                </tr>
                                <tr>
                                    <td>铜Cu，mg</td>
                                    <td>4.00</td>
                                    <td>5.00</td>
                                </tr>
                                <tr>
                                    <td>碘I，mg</td>
                                    <td>0.12</td>
                                    <td>0.14</td>
                                </tr>
                                <tr>
                                    <td>铁Fe，mg</td>
                                    <td> 70</td>
                                    <td> 80</td>
                                </tr>
                                <tr>
                                    <td>锰Mn，mg</td>
                                    <td> 16</td>
                                    <td> 20</td>
                                </tr>
                                <tr>
                                    <td>硒Se，mg</td>
                                    <td> 0.15</td>
                                    <td> 0.15</td>
                                </tr>
                                <tr>
                                    <td>锌Zn，mg</td>
                                    <td> 50</td>
                                    <td> 50</td>
                                </tr>
                                <tr>
                                    <td colspan="3">维生素和脂肪酸，%或每千克饲粮含量</td>
                                </tr>
                                 <tr>
                                    <td>维生素A，IU</td>
                                    <td> 3600</td>
                                    <td> 2000</td>
                                </tr>
                                <tr>
                                    <td>维生素D3，IU</td>
                                    <td> 180</td>
                                    <td> 200</td>
                                </tr>
                               
                                <tr>
                                    <td>维生素E，IU</td>
                                    <td> 36</td>
                                    <td> 44</td>
                                </tr>
                                <tr>
                                    <td>维生素K，mg</td>
                                    <td> 0.40</td>
                                    <td> 0.50</td>
                                </tr>
                                <tr>
                                    <td>硫胺素，mg</td>
                                    <td> 1.00</td>
                                    <td> 1.00</td>
                                </tr>
                                <tr>
                                    <td>核黄素，mg</td>
                                    <td> 3.20</td>
                                    <td> 3.75</td>
                                </tr>
                                <tr>
                                    <td>泛酸，mg</td>
                                    <td> 10.00</td>
                                    <td> 12.00</td>
                                </tr>
                                <tr>
                                    <td>烟酸，mg</td>
                                    <td> 8.00</td>
                                    <td> 10.00</td>
                                </tr>
                               <tr>
                                    <td>吡哆醇，mg</td>
                                    <td> 1.00</td>
                                    <td> 1.00</td>
                                </tr>
                                <tr>
                                    <td>生物素，mg</td>
                                    <td> 0.16</td>
                                    <td> 0.20</td>
                                </tr>
                                
                                <tr>
                                    <td>叶酸，mg</td>
                                    <td> 1.10</td>
                                    <td> 1.30</td>
                                </tr>
                                <tr>
                                    <td>维生素B12，μg</td>
                                    <td>12.00</td>
                                    <td>15.00</td>
                                </tr>
                                 <tr>
                                    <td>胆碱，g</td>
                                    <td> 1.00</td>
                                    <td> 1.00</td>
                                </tr>
                                <tr>
                                    <td>亚油酸，</td>
                                    <td> 0.10</td>
                                    <td> 0.10</td>
                                </tr>
                            </table>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="13、地方种猪后备母猪每千克饲粮中养分含量" name="13">
                    <van-row>
                        <van-col span="24">
                             <van-col span="24">
                                88%干物质
                            </van-col>
                          
                            <table class="health_tab">
                                <tr>
                                    <th style="width:100px;">体重，kg</th>
                                    <th>10~20</th>
                                    <th>20~40</th>
                                    <th>40~70</th>
                                </tr>
                                <tr>
                                    <td>日增重ADG，kg/d</td>
                                    <td> 0.30</td>
                                    <td> 0.40</td>
                                    <td> 0.59</td>
                                </tr>
                                <tr>
                                    <td>预期采食量ADFI,kg/d</td>
                                    <td> 0.63</td>
                                    <td> 1.08</td>
                                    <td> 1.65</td>
                                </tr>
                                <tr>
                                    <td>饲料/增重，F/G</td>
                                    <td> 2.10</td>
                                    <td>2.70</td>
                                    <td> 3.30</td>
                                </tr>
                                <tr>
                                    <td>饲粮消化能含量DE，MJ/kg(kcal/kg)</td>
                                    <td> 12.97(3100)</td>
                                    <td> 12.55(3000)</td>
                                    <td> 12.15(2900)</td>
                                </tr>
                                <tr>
                                    <td>粗蛋白质CP，%</td>
                                    <td>18.0</td>
                                    <td>16.0</td>
                                    <td>14.0</td>
                                </tr>
                                <tr>
                                    <td>能量蛋白比DE/CP,kg%(kcal/%)</td>
                                    <td>721(172)</td>
                                    <td>784(188)</td>
                                    <td>868(207)</td>
                                </tr>
                                <tr>
                                    <td>赖氨酸能量比Lys/DE,g/MJ(g/Mcal)</td>
                                    <td>0.77(3.23)</td>
                                    <td>0.70(2.93)</td>
                                    <td>0.48(2.00)</td>
                                </tr>
                                <tr>
                                    <td colspan="4">氨基酸，%</td>
                                </tr>
                                <tr>
                                    <td>赖氨酸Lys</td>
                                    <td> 1.00</td>
                                    <td> 0.88</td>
                                    <td> 0.67</td>
                                </tr>
                                <tr>
                                    <td>蛋氨酸+胱氨酸Met+Cys</td>
                                    <td> 0.50</td>
                                    <td> 0.44</td>
                                    <td> 0.36</td>
                                </tr>
                                <tr>
                                    <td>苏氨酸Thr</td>
                                    <td> 0.59</td>
                                    <td> 0.53</td>
                                    <td> 0.43</td>
                                </tr>
                                <tr>
                                    <td>色氨酸Trp</td>
                                    <td> 0.15</td>
                                    <td> 0.13</td>
                                    <td> 0.11</td>
                                </tr>
                                <tr>
                                    <td>异亮氨酸Ile</td>
                                    <td> 0.56</td>
                                    <td> 0.49</td>
                                    <td> 0.41</td>
                                </tr>
                                <tr>
                                    <td colspan="4">矿物元素，%</td>
                                </tr>
                                <tr>
                                    <td>钙Ca，%</td>
                                    <td> 0.74</td>
                                    <td> 0.62</td>
                                    <td> 0.53</td>
                                </tr>
                                <tr>
                                    <td>总磷，%</td>
                                    <td>0.60</td>
                                    <td>0.53</td>
                                    <td>0.44</td>
                                </tr>
                                <tr>
                                    <td>有效磷，%</td>
                                    <td>0.37</td>
                                    <td>0.28</td>
                                    <td>0.20</td>
                                </tr>
                            </table>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="14、肉脂型种公猪每千克饲粮养分含量" name="14">
                    <van-row>
                        <van-col span="24">
                             <van-col span="24">
                                88%干物质
                            </van-col>
                          
                            <table class="health_tab">
                                <tr>
                                    <th style="width:100px;">体重，kg</th>
                                    <th>10~20</th>
                                    <th>20~40</th>
                                    <th>40~70</th>
                                </tr>
                                <tr>
                                    <td>日增重ADG，kg/d</td>
                                    <td> 0.35</td>
                                    <td> 0.45</td>
                                    <td> 0.59</td>
                                </tr>
                                <tr>
                                    <td>采食量ADFI,kg/d</td>
                                    <td> 0.72</td>
                                    <td> 1.17</td>
                                    <td> 1.67</td>
                                </tr>
                                <tr>
                                    <td>饲粮消化能含量DE，MJ/kg(kcal/kg)</td>
                                    <td> 12.97(3100)</td>
                                    <td> 12.55(3000)</td>
                                    <td> 12.55(3000)</td>
                                </tr>
                                <tr>
                                    <td>粗蛋白质CP，%</td>
                                    <td>18.8</td>
                                    <td>17.5</td>
                                    <td>14.6</td>
                                </tr>
                                <tr>
                                    <td>能量蛋白比DE/CP,kg%(kcal/%)</td>
                                    <td>690（165）</td>
                                    <td>717（171）</td>
                                    <td>860（205）</td>
                                </tr>
                                <tr>
                                    <td>赖氨酸能量比Lys/DE,g/MJ(g/Mcal)</td>
                                    <td>0.81（0.39）</td>
                                    <td>0.73（3.07）</td>
                                    <td>0.50（2.09）</td>
                                </tr>
                                <tr>
                                    <td colspan="4">氨基酸，%</td>
                                </tr>
                                <tr>
                                    <td>赖氨酸Lys</td>
                                    <td> 1.05</td>
                                    <td> 0.92</td>
                                    <td> 0.73</td>
                                </tr>
                                <tr>
                                    <td>蛋氨酸+胱氨酸Met+Cys</td>
                                    <td> 0.53</td>
                                    <td> 0.47</td>
                                    <td> 0.37</td>
                                </tr>
                                <tr>
                                    <td>苏氨酸Thr</td>
                                    <td> 0.62</td>
                                    <td> 0.55</td>
                                    <td> 0.47</td>
                                </tr>
                                <tr>
                                    <td>色氨酸Trp</td>
                                    <td> 0.16</td>
                                    <td> 0.13</td>
                                    <td> 0.12</td>
                                </tr>
                                <tr>
                                    <td>异亮氨酸Ile</td>
                                    <td> 0.59</td>
                                    <td> 0.52</td>
                                    <td> 0.45</td>
                                </tr>
                                <tr>
                                    <td colspan="4">矿物元素，%</td>
                                </tr>
                                <tr>
                                    <td>钙Ca，%</td>
                                    <td> 0.74</td>
                                    <td> 0.64</td>
                                    <td> 0.55</td>
                                </tr>
                                <tr>
                                    <td>总磷，%</td>
                                    <td>0.60</td>
                                    <td>0.55</td>
                                    <td>0.46</td>
                                </tr>
                                <tr>
                                    <td>有效磷，%</td>
                                    <td>0.37</td>
                                    <td>0.29</td>
                                    <td>0.21</td>
                                </tr>
                            </table>
                        </van-col>
                    </van-row>
                </van-collapse-item>
                <van-collapse-item title="15、肉脂型种公猪每日每头养分需要量" name="14">
                    <van-row>
                        <van-col span="24">
                             <van-col span="24">
                                88%干物质
                            </van-col>
                          
                            <table class="health_tab">
                                <tr>
                                    <th style="width:100px;">体重，kg</th>
                                    <th>10~20</th>
                                    <th>20~40</th>
                                    <th>40~70</th>
                                </tr>
                                <tr>
                                    <td>日增重ADG，kg/d</td>
                                    <td> 0.35</td>
                                    <td> 0.45</td>
                                    <td> 0.50</td>
                                </tr>
                                <tr>
                                    <td>采食量ADFI,kg/d</td>
                                    <td> 0.72</td>
                                    <td> 1.17</td>
                                    <td> 1.67</td>
                                </tr>
                                <tr>
                                    <td>饲粮消化能含量DE，MJ/kg(kcal/kg)</td>
                                    <td> 12.97(3100)</td>
                                    <td> 12.55(3000)</td>
                                    <td> 12.55(3000)</td>
                                </tr>
                                <tr>
                                    <td>粗蛋白质CP，%</td>
                                    <td>135.4</td>
                                    <td>204.8</td>
                                    <td>243.8</td>
                                </tr>
                                <tr>
                                    <td colspan="4">氨基酸，%</td>
                                </tr>
                                <tr>
                                    <td>赖氨酸Lys</td>
                                    <td> 7.6</td>
                                    <td> 10.8</td>
                                    <td> 12.2</td>
                                </tr>
                                <tr>
                                    <td>蛋氨酸+胱氨酸Met+Cys</td>
                                    <td> 3.8</td>
                                    <td> 10.8</td>
                                    <td> 12.2</td>
                                </tr>
                                <tr>
                                    <td>苏氨酸Thr</td>
                                    <td> 4.5</td>
                                    <td> 10.8</td>
                                    <td> 12.2</td>
                                </tr>
                                <tr>
                                    <td>色氨酸Trp</td>
                                    <td> 1.2</td>
                                    <td> 10.8</td>
                                    <td> 12.2</td>
                                </tr>
                                <tr>
                                    <td>异亮氨酸Ile</td>
                                    <td> 4.2</td>
                                    <td> 10.8</td>
                                    <td> 12.2</td>
                                </tr>
                                <tr>
                                    <td colspan="4">矿物元素，%</td>
                                </tr>
                                <tr>
                                    <td>钙Ca，%</td>
                                    <td> 5.3</td>
                                    <td> 10.8</td>
                                    <td> 12.2</td>
                                </tr>
                                <tr>
                                    <td>总磷，%</td>
                                    <td> 4.3</td>
                                    <td> 10.8</td>
                                    <td> 12.2</td>
                                </tr>
                                <tr>
                                    <td>有效磷，%</td>
                                    <td> 2.7</td>
                                    <td> 10.8</td>
                                    <td> 12.2</td>
                                </tr>
                            </table>
                        </van-col>
                    </van-row>
                </van-collapse-item>
            </van-collapse>
            <van-col span="24" style="padding:.2rem; color:#333;">
                       主要参照标准：DB11/T 574-2008；GB/T 17824.2-2008；GB/T 20014.9-2013；GB/T 17824.3-2008；GB/T 32149-2015；GB/T 17823-2009；NY/T65-2004      
            </van-col>
        </van-row>
        
      
    </div>
    <Top :btnFlag="btnFlag"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Top from '@/components/top.vue'
import { labbiosafetyeval } from '@/api/resetApi.js'

export default {
  name: 'health_rear',
  components: {
    Top
  },
  data(){
    return{
        activeNames: ['1'],
        grade_num: '',
        btnFlag:false,
        eval_result: '',
        browser: {
            trident: navigator.userAgent.indexOf('Trident') > -1, //IE内核
            presto: navigator.userAgent.indexOf('Presto') > -1, //opera内核
            webKit: navigator.userAgent.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
            gecko: navigator.userAgent.indexOf('Gecko') > -1 && navigator.userAgent.indexOf('KHTML') == -1, //火狐内核
            mobile: !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/) || !!navigator.userAgent.match(/AppleWebKit/), //是否为移动终端
            ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1, //android终端或者uc浏览器
            iPhone: navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: navigator.userAgent.indexOf('iPad') > -1, //是否iPad
            webApp: navigator.userAgent.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
        },
        goodsList: [],
        isWx:1,
    };
  },
  created(){
    const ua = window.navigator.userAgent.toLowerCase();
    if(ua.indexOf('micromessenger') == -1) {
      this.isWx = 1
    }else{
      this.isWx = 2
    }
  },
  methods: {
    async labbiosafetyeval() {
      let qs = require('qs');
      let data = qs.stringify(JSON.parse(this.laboratorylist))
      const res = await labbiosafetyeval(data)
      console.log(res)
      try {
        if (res.data.code === 1) {
          this.grade_num = res.data.grade_num
          if (res.grade_num>=76) {
            this.eval_result = res.data.eval_result+',继续保持哦～'
          } else{
            this.eval_result = res.data.eval_result+',待整改完善'
          }
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    retest() {
      this.$store.state.report.laboratorydata = []
      this.$router.back(-1)
    },
    laboratorys() {
      if (this.browser.android) {
        ZKAPP.laboratory();
      }else {
        window.webkit.messageHandlers.laboratory.postMessage({name: 'zhangyutang', age: 12});
      }
    },
    onClickLeft() {
      this.$router.back(-1)
    },
  }
}
</script>

<style lang="scss">
.health_rear{
    .van-cell__title{
        text-align: left;
        span{
            // font-weight: bold;
            font-size: 16px;
        }
    }
    .health_tab{
        width:100%;
        table-layout: fixed;
        border-collapse:collapse;
        tr td{
            border:1px  solid #CCCCCC;
            padding: .05rem;
            word-wrap : break-word;
            text-align: center;
            vertical-align: middle;
        }
        th{
            border:1px  solid #CCCCCC;
            padding: .05rem;
            font-size: 14px;
            word-wrap : break-word;
            text-align: center;
            vertical-align: middle;
        }
    }
    .van-col {
      
        
        font-size: 14px;
        line-height: 20px;
        text-align: left;
        background-clip: content-box;
        color: #4C4C4C;
        border: 1px solid #F5F5F5;
       
       
        margin: 5px;
    }
    .van-collapse-item__content{
        background:#F5F5F5 ;
        padding: 0 16px 16px;
    }
    
    .van-nav-bar .van-icon{
        color: #999999;
    }
    .swine_wrap{
        width: 100%; 
        font-size: 14px;
    }
    .health_rear_title{
        padding: .2rem;
        background: #F6F9FF;
        text-align: left;
        font-weight: bold;
        font-size: 16px;
    }
    .health_rear_card{
        padding: .2rem;
        .van-col {
            margin-bottom: 10px;
            
            font-size: 14px;
            line-height: 50px;
            text-align: center;
            background-clip: content-box;
            color: #4C4C4C;
            border: 1px solid #F5F5F5;
            padding: 0!important;
            width: 30%;
            margin: 5px;
        }
    }
    .health_rear_icon{
        // padding: .2rem;
            // background-color: #66c6f2;
        // border: 1px solid #F5F5F5;
    }
    
}
.van-button--normal {
  width: 40%;
  margin: 10px;
}
.navheight {
  height: 46px;
}
.res2{
  width: 200px;
  height: 200px;
  text-align: center;
  margin: 50px auto 10px;
  line-height: 180px;
  color:#fff;
}
.res{
  width: 200px;
  height: 200px;
  background: url(../../assets/subjectimg/t1.png) top center no-repeat;
  background-size: 100% 100%; 
  text-align: center;
  margin: 50px auto 10px;
  line-height: 180px;
  color:#fff;

}
.res1{
  width: 200px;
  height: 200px;
  background: url(../../assets/subjectimg/b1.png) top center no-repeat;
  background-size: 100% 100%; 
  text-align: center;
  margin: 50px auto 10px;
  line-height: 180px;
}
.branch{
  font-size: 70px;
}
.branch1{
  font-size: 24px;
}
img{
  display: inline-block;
  vertical-align: middle;
}
.res_text{
  padding: 60px 0;
  font-size: 0;
  text-align: center;
}
.res_text span{
  margin-left: 10px;
  vertical-align: middle;
  font-size: 20px;
  color: #4A4A4A;
}
.res_text img{
  width: 30px;
  height: 30px;
}
.btn_bottom {
  font-size: 0;
}
</style>
